
const translations = {
    "Notice!": "Tähelepanu!",
    "Are you sure that you want to delete this?": "Kas oled kindel, et soovid selle kustutada?",
    "Confirm": "Kinnita",
    "Cancel": "Katkesta",
    "Min": "Min",
    "Max": "Maks",
    "Before": "Enne",
    "After": "Pärast",
    "w": "n",
    "week": "nädal",
    "weeks": "nädalat",
    "d": "p",
    "day": "päev",
    "days": "päeva",
    "Due date": "Tähtaeg",
    "Start date": "Algus",
    "Internal date": "Sisemine tähtaeg",
    "Notes": "Märkmed",
    "Document": "Dokument",
    "Email": "E-post",
    "Billing": "Arveldamine",
    "Add": "Lisa",
    "Archived": "Arhiveeritud",
    "Cancelled": "Tühistatud",
    "Active": "Aktiivne",
    "Inactive": "Mitteaktiivne",
    "Client company": "Kliendi ettevõte",
    "General info": "Üldinfo",
    "Digitisation of client documents": "Kliendi dokumentide digiteerimine",
    "Client portal": "Kliendiportaal",
    "Documents": "Dokumendid",
    "Members": "Kasutajad",
    "Preferences": "Seaded",
    "Yes": "Jah",
    "No": "Ei",
    "Total hours": "Tunnid kokku",
    "Extra hours": "Lisatunnid",
    "Client": "Klient",
    "Tasks": "Ülesanded",
    "Disable Uku’s task templates": "Peida Uku tööplaanid",
    "Set the estimation as time when the exact value is not entered": "Määra ülesande ajakuluks prognoositud aeg, kui täpne aeg on sisestamata",
    "Checklist must be completed to finish the task": "Checklist peab olema linnutatud ülesande lõpetamiseks",
    "Disable topic management for members": "Keela kasutajatel teemade lisamine",
    "Disable time edit for members": "Keela kasutajatel ajakirjete korrigeerimine",
    "Allow time entries in future": "Luba ajakirjed tulevikus",
    "Show all dependent tasks in the calendar": "Näita kalendris kõiki sõltuvaid ülesandeid",
    "Clients": "Kliendid",
    "Disable adding new clients for members": "Keela kasutajatel klientide lisamine",
    "Only administrators can edit documents": "Ainult peakasutajad saavad muuta dokumente",
    "Allow digitisation of client documents": "Luba kliendi dokumentide digiteerimine",
    "Use my Microsoft account": "Kasuta minu Microsofti kontot",
    "Disconnect my Microsoft account": "Ühenda lahti Microsofti kontost",
    "Connect my Microsoft account": "Ühenda mu Microsofti konto",
    "Use my google account": "Kasuta minu Google kontot",
    "Connect my google account": "Ühenda mu Google’i konto",
    "Disconnect my google account": "Ühenda lahti Google kontost",
    "Use my Xero account": "Kasuta minu Xero kontot",
    "Connect my Xero account": "Ühenda mu Xero konto",
    "Disconnect my Xero account": "Ühenda lahti Xero kontost",
    "Emails": "E-kirjad",
    "Daily agenda": "Päeva ülevaade",
    "Unread notifications": "Lugemata teavitused",
    "Task assigned to me": "Mulle suunatud ülesanne",
    "Weekly summary": "Nädala kokkuvõte",
    "Monthly summary": "Kuu kokkuvõte",
    "Updates and tips": "Uuendused ja nõuanded",
    "Overdue": "Hilinenud",
    "1 day": "1 päev",
    "1 day overdue": "1 päev hilinenud",
    "{0} days": "{0} päeva",
    "{0} days overdue": "{0} päeva hilinenud",
    "{0} minute ago": "{0} minutit tagasi",
    "{0} minutes ago": "{0} minutit tagasi",
    "{0} hour ago": "{0} tundi tagasi",
    "{0} hours ago": "{0} tundi tagasi",
    "Sunday": "Pühapäev",
    "Monday": "Esmaspäev",
    "Tuesday": "Teisipäev",
    "Wednesday": "Kolmapäev",
    "Thursday": "Neljapäev",
    "Friday": "Reede",
    "Saturday": "Laupäev",
    "Sun": "P",
    "Mon": "E",
    "Tue": "T",
    "Wed": "K",
    "Thu": "N",
    "Fri": "R",
    "Sat": "L",
    "January": "Jaanuar",
    "February": "Veebruar",
    "March": "Märts",
    "April": "Aprill",
    "May": "mai",
    "June": "Juuni",
    "July": "Juuli",
    "August": "August",
    "September": "September",
    "October": "Oktoober",
    "November": "November",
    "December": "Detsember",
    "Jan": "jaan",
    "Feb": "veebr",
    "Mar": "märts",
    "Apr": "apr",
    "Jun": "juuni",
    "Jul": "juuli",
    "Aug": "aug",
    "Sep": "sept",
    "Oct": "okt",
    "Nov": "nov",
    "Dec": "dets",
    "Today": "Täna",
    "Yesterday": "Eile",
    "Day": "Päev",
    "Days": "Päeva",
    "+{0} d": "+{0} p",
    "+{0} wd": "+{0} tp",
    "Weekly {0}": "Iga nädal {0}",
    "Every {0}. week {1}": "Iga {0}. nädal {1}",
    "{0}": "{0}",
    "Monthly {0}. d": "Iga kuu {0}. kp",
    "Every {0}. month {1}. d": "Iga {0}. kuu {1}. kp",
    "{0}. d": "{0}. kp",
    "Quarterly {0}. month {1}. d": "Iga kvartali {0}. kuu {1}. kp",
    "Every {0}. quarter {1}. month {2}. d": "Iga {0}. kvartali {1}. kuu {2}. kpp",
    "{0}. month {1}. d": "{0}. kuu {1}. kp",
    "Yearly {0}": "Iga aasta {0}",
    "Every {0}. year {1}": "Iga {0}. aasta {1}",
    "Mo": "E",
    "Tu": "T",
    "We": "K",
    "Th": "N",
    "Fr": "R",
    "Sa": "L",
    "Su": "P",
    "and": "ja",
    "{0}w": "{0}n",
    "{0}d": "{0}p",
    "before": "enne",
    "after": "pärast",
    "Project": "Projekt",
    "Quarter": "Kvartal",
    "Add logo": "Logo lisamine",
    "Add your photo": "Lisa enda foto",
    "Adding file failed": "Faili lisamine ebaõnnestus",
    "Please check the file.": "Palun kontrolli faili.",
    "You can only add pictures.": "Lisada saab ainult pilte.",
    "Error": "Tõrge",
    "Create new topic": "Loo uus teema",
    "Name": "Nimi",
    "Close": "Sulge",
    "Find topic...": "Vali teema…",
    "New topic": "Uus teema",
    "Invalid format": "Vigane formaat",
    "Demo company account": "Demo ettevõtte konto",
    "Demo account will be deleted later. Do this for testing purposes only!": "Demo konto kustutatakse hiljem. Kasuta seda ainult testimise eesmärgil!",
    "Subscribe": "Vali pakett",
    "Start demo": "Käivita demo",
    "End demo": "Lõpeta demo",
    "Free trial is expired - {0}": "Prooviperiood on läbi - {0}",
    "Free trial {1} {2} left - {0}": "Prooviperiood {1} {2} alles - {0}",
    "Add time": "Lisa aeg",
    "Billable": "Arveldatav",
    "Date": "Kuupäev",
    "Start": "Algus",
    "End": "Lõpeta",
    "Duration": "Kestus",
    "Split duration equally": "Jaga aeg võrdselt",
    "Required field": "Kohustuslik väli",
    "Members list": "Kasutajate nimekiri",
    "Edit fields": "Kuvatavad väljad",
    "Maximum number of selected columns has been exceeded": "Maksimaalne valitud veergude arv on ületatud",
    "If you want to add a new column to the report, please remove an existing one first.": "Kui soovid lisada aruandesse uue veeru, siis eemalda enne mõni olemasolev.",
    "Snooze until...": "Lükka edasi…",
    "Select date & time": "Vali kuupäev ja kellaaeg",
    "Tomorrow": "Homme",
    "Later this week": "Hiljem see nädal",
    "Next week": "Järgmine nädal",
    "Add task": "Lisa ülesanne",
    "Checklist": "Checklist",
    "Start timer": "Käivita stopper",
    "Add an item": "Lisa rida",
    "Add checklist item": "Lisa checklisti rida",
    "Convert to a task": "Tee ülesandeks",
    "Delete": "Kustuta",
    "Delegate to...": "Delegeeri ...",
    "Please select tasks from the same account": "Valitud ülesanded peavad kuuluma sama konto alla",
    "Follow": "Jälgi",
    "Expand sidebar": "Ava inforiba",
    "Nicely done!": "Hästi tehtud!",
    "You've finished all your tasks, take a second to recharge": "Oled kõik oma ülesanded lõpetanud, võta aega enda turgutamiseks",
    "Search tasks...": "Otsi ülesandeid",
    "Search": "Otsi",
    "select/unselect all": "Kõik / Tühista",
    "Add new client": "Lisa uus klient",
    "Account": "Konto",
    "Client name": "Kliendi nimi",
    "Select client": "Vali klient",
    "New client": "Lisa uus klient",
    "Must be an integer": "Peab olema täisarv",
    "Must be a number": "Peab sisestama numbrit",
    "Dashboard": "Töölaud",
    "Calendar": "Kalender",
    "Report": "Raport",
    "Monitoring": "Monitooring",
    "Suppliers": "Tarnijad",
    "Events": "Sündmused",
    "Projects": "Projektid",
    "Help": "Abi",
    "Invite a friend": "Soovita sõpra",
    "Settings & Apps": "Seaded & Äpid",
    "Profile": "Profiil",
    "Collapse menu": "Peida menüü",
    "Expand menu": "Laienda menüü",
    "Are you sure to delete this attachment?": "Kas oled kindel, et soovid manuse kustutada?",
    "Select": "Vali",
    "Edit contacts": "Muuda kontakte",
    "Add member": "Lisa kasutaja",
    "Add note": "Lisa märkmed",
    "Open": "Ava",
    "Reports": "Raportid",
    "Billing notes": "Arveldamise märkmed",
    "Pinned notes": "Olulised märkmed",
    "Sub-companies": "Tütarettevõtted",
    "Contacts": "Kontaktid",
    "Event info": "Sündmuse üldinfo",
    "Project info": "Projekti üldinfo",
    "Summary": "Kokkuvõte",
    "Task": "Ülesanne",
    "Time": "Aeg",
    "Collapse sidebar": "Peida inforiba",
    "Client Overview": "Kliendi ülevaade",
    "Event Overview": "Sündmuse ülevaade",
    "Project Overview": "Projekti ülevaade",
    "Edit client": "Muuda kliendi andmeid",
    "Edit event": "Muuda üritust",
    "Edit project": "Muuda projekti",
    "Show all": "Näita kõiki",
    "Collapse": "Sulge",
    "by": ",",
    "View all": "Vaata kõiki",
    "Copied to clipboard": "Lõikelauale kopeeritud",
    "Client portal invite sent on {0}": "Kliendiportaali kutse saadeti {0}",
    "Client portal invite has not been sent": "Kliendiportaali kutset ei ole saadetud",
    "Resend invite": "Kutsu uuesti",
    "Send invite": "Saada kutse",
    "Invite sent": "Kutse saadetud",
    "Add company event": "Lisa ettevõtte sündmus",
    "Company": "Ettevõte",
    "Info": "Info",
    "Holiday": "Puhkepäev",
    "All day(s)": "Täispäev(ad)",
    "End date": "Lõpp",
    "From": "Alates",
    "Until": "Kuni",
    "Hours": "Tunde",
    "Link": "Link",
    "Save": "Salvesta",
    "Are you sure that you want to delete this company calendar event?": "Kas oled kindel, et soovid kalendrisündmuse kustutada?",
    "Location of client folder in your document management system": "Kliendikausta asukoht dokumendihaldussüsteemis",
    "Defined main folder": "Määratletud põhikaust",
    "Custom folder": "Kohandatud kaustik",
    "Add new role": "Lisa uus roll",
    "New role": "Uus roll",
    "Access enabled": "Ligipääs lubatud",
    "Waiting for files": "Ootan faile",
    "Uploaded": "Üles laaditud",
    "Uploading...": "Laadime üles…",
    "Client members": "Kliendi kasutajad",
    "Email settings": "E-posti seaded",
    "Or connect new email address": "Või ühenda uus e-posti aadress",
    "Connect with Microsoft Exchange or other email server (SMTP)": "Ühenda Microsoft Exchange’i või mõne teise e-posti serveriga (SMTP)",
    "Test email sent": "Testkiri saadetud",
    "Email address": "E-posti aadress",
    "Reply address": "Vastuse aadress",
    "Sender name": "Saatja nimi",
    "Who can use?": "Kes saab kasutada?",
    "Client default address": "Kliendi vaikimisi aadress",
    "Invalid e-mail": "Vigane e-post",
    "Role": "Roll",
    "E-mail": "E-post",
    "Mobile phone": "Mobiiltelefon",
    "Work phone": "Töötelefon",
    "Language": "Keel",
    "Birthday": "Sünnipäev",
    "Are you sure to delete this contact?": "Kas oled kindel, et soovid kontakti kustutada?",
    "Manage contact fields": "Seadista kontakti väljasid",
    "Administrative Assistant": "Assistent",
    "Board member": "Juhatuse liige",
    "CEO": "Tegevjuht",
    "Add contact": "Lisa kontakt",
    "Contact person": "Kontaktisik",
    "Leave page?": "Kas soovid lehelt lahkuda?",
    "Changes that you made may not be saved": "Tehtud muudatusi ei salvestata",
    "Leave": "Lahku",
    "Validate tasks": "Valideeri ülesanded",
    "The Contact you are trying to delete is an assignee in {0} tasks. Remove the contact from tasks to continue.": "Kontakt, keda proovid kustutada, on {0} ülesande küljes. Jätkamiseks eemalda kontakt ülesannetelt.",
    "Continue": "Jätka",
    "Super! We're importing your clients...": "Super! Impordime Sinu kliente..",
    "Feel free to leave this page. We will pop up a notification when the import is prepared. Then you need to confirm the clients you want to add to Uku.": "Sa võid sellelt lehelt lahkuda. Kui import on valmis, anname Sulle teavitusega märku. Seejärel pead kinnitama kliendid, kelle soovid Ukusse lisada.",
    "Please wait...": "Palun oota…",
    "Setup API keys": "Seadista API võtmed",
    "You have two options": "Sul on kaks valikut",
    "how to setup API keys": "kuidas lisada Merit Aktivas API võtmeid",
    "Custom import": "Kohandatud import",
    "To import clients and volume of work from !INTEGRATION, Uku needs !INTEGRATION API key for every client.": "Klientide ja töömahu importimiseks programmist !INTEGRATION vajab Uku !INTEGRATION API võtit iga kliendi kohta.",
    "1. <span class=font-weight-medium>Continue</span> - Uku automatically creates API keys for every client": "1. <span class=font-weight-medium>Jätka</span> - Uku genereerib automaatselt API võtmed",
    "1. <span class=font-weight-medium>Custom import</span> - Uku connects only with existing UKU API keys. Create API keys manually in !INTEGRATION before import. Read:": "2. <span class=font-weight-medium>Kohandatud import</span> - Uku impordib ainult kliendid, kellel on Merit Aktivas “UKU” nimeline API võti. Loe:",
    "(it takes a lot of time)": "(lisatakse ükshaaval)",
    "Import Clients": "Lisa ja uuenda andmed",
    "Country": "Riik",
    "Please choose your country": "Palun vali riik",
    "Password": "Salasõna",
    "Start import": "Käivita import",
    "Insert !INTEGRATION login details (it’s secure) to give one time access to import clients and API keys. Please note that you will get logged out from !INTEGRATION in other browsers.": "Sisesta enda !INTEGRATION e-mail ja parool (see on turvaline), et anda ühekordne ligipääs klientide ja API võtmete impordiks. Infoks, Sind logitakse programmist !INTEGRATION teises brauseri aknas välja.",
    "Update invoice status": "Uuenda arve staatust",
    "Update now": "Uuenda kohe",
    "Daily @ 14:00": "Igapäevaselt @14:00",
    "Daily @ 18:00": "Igapäevaselt @18:00",
    "Updating invoice statuses, please wait...": "Uuendan arve staatust, palun oota…",
    "Your import is ready": "Sinu import on ootab kinnitamist",
    "In the final step you need to confirm the clients you want to add to uku": "Viimase etapina, palun kinnita kliendid, keda soovid Ukusse lisada.",
    "Let's go": "Kinnitama",
    "Import again": "Impordi uuesti",
    "Do you have new clients to import?": "Kas Soovid importida uusi kliente?",
    "Yes, i do": "JAH",
    "View last import": "Kuva viimane import",
    "Email server": "E-posti server",
    "Email provider": "Teenusepakkuja",
    "Host": "Serveri aadress",
    "Port": "Port",
    "Security": "Turvalisus",
    "Sender email": "Saatja e-post",
    "Username": "Kasutajanimi",
    "Test connection": "Testi ühendust",
    "How to set up": "Kuidas seadistada",
    "Only administrators can activate the app": "Ainult administraatorid saavad äppi aktiveerida",
    "You are in the waiting list": "Oled ootejärjekorras",
    "We onboard all applicants one by one": "Registreeri huvi ja teavitame sind kui saad rakendust proovida",
    "Connected": "Ühendatud",
    "Activated": "Aktiveeritud",
    "Join waiting list": "Soovin proovida",
    "Activate": "Aktiveeri",
    "Unsubscribe from waiting list": "Loobun soovist",
    "Deactivate app": "Deaktiveeri",
    "Disconnect": "Ühenda lahti",
    "Hide expanded content": "Peida laiendatud sisu",
    "Show trimmed content": "Näita kärbitud sisu",
    "Email not delivered": "Kirja saatmine ebaõnnestus",
    "Sent, but fallback to Uku email": "Saadetud Uku poolt, kuna Sinu e-posti seaded ei toimi",
    "Unknown error": "Tundmatu viga",
    "to": "->",
    "automatically": "automaatselt",
    "in any minute": "kohe",
    "on {0},": "{0},",
    "or": "või",
    "Send now": "Saada kohe",
    "Uku will no longer send email": "Uku ei saada enam e-kirju",
    "Uku <span class='subtitle-2'>is sending</span> email": "Uku saadab <span class='subtitle-2'>e-kirja</span>",
    "__From_email": "Saatja",
    "Set up email": "Seadista kirjade saatmine",
    "Client default": "Kliendi vaikimisi",
    "Subject": "Teema",
    "Edit email": "Muuda e-kirja",
    "Template": "Mall",
    "Cc": "Koopia",
    "Bcc": "Pimekoopia",
    "__To_email": "Saaja",
    "__Cc_email": "Cc",
    "__Bcc_email": "Bcc",
    "Add template": "Lisa mall",
    "Add automation": "Lisa automatiseerimine",
    "Add placeholder": "Lisa muutuja",
    "Format text": "Vorminda teksti",
    "Add attachment": "Lisa manus",
    "Send": "Saada",
    "Save automation": "Salvesta automatiseerimine",
    "Choose email template": "Vali e-kirja mall",
    "All languages": "Kõik keeled",
    "No templates found.": "Malle ei leitud.",
    "Edit email template": "Muuda e-kirja malli",
    "Are you sure you want to delete this template? Some tasks will be affected": "Kas oled kindel, et soovid malli kustutada? Mõned ülesanded on sellega seotud",
    "Are you sure you want to delete this template?": "Kas oled kindel, et soovid malli kustutada?",
    "Are you sure you want to save this template, the following tasks will be affected?": "Kas oled kindel, et soovid malli salvestada? Mõned ülesanded on sellega seotud",
    "Template name": "Malli nimi",
    "Edit template": "Muuda malli",
    "Send email": "Saada kiri",
    "on": ", kui on",
    "Ok": "Ok",
    "Supplier": "Tarnija",
    "Event": "Sündmus",
    "Contact": "Kontakt",
    "Validation failed": "Valideerimine ebaõnnestus",
    "Saving supplier failed": "Tarnija salvestamine ebaõnnestus",
    "Saving client failed": "Kliendi salvestamine ebaõnnestus",
    "Saving project failed": "Projekti salvestamine ebaõnnestus",
    "several values": "mitu väärtust",
    "values": "väärtust",
    "is": "on",
    "Add filter": "Lisa filter",
    "Update": "Uuenda",
    "forever": "igavesti",
    "Last week": "Eelmine nädal",
    "This week": "See nädal",
    "Last month": "Eelmine kuu",
    "This month": "See kuu",
    "Next month": "Järgmine kuu",
    "Last year": "Eelmine aasta",
    "This year": "See aasta",
    "This quarter": "See kvartal",
    "Next quarter": "Järgmine kvartal",
    "Last quarter": "Eelmine kvartal",
    "Client group": "Kliendigrupp",
    "Topic": "Teema",
    "Member": "Kasutaja",
    "Primary member": "Vaikimisi kasutaja",
    "Client status": "Kliendi staatus",
    "Active clients": "Aktiivsed kliendid",
    "Inactive clients": "Mitteaktiivsed kliendid",
    "All": "Kõik",
    "Project status": "Projekti staatus",
    "Member status": "Kasutaja staatus",
    "Active members": "Aktiivsed kasutajad",
    "Limited members": "Seadistamisel kasutajad",
    "Inactive members": "Mitteaktiivsed kasutajad",
    "Contract status": "Lepingu staatus",
    "Active contracts": "Aktiivsed lepingud",
    "Pending contracts": "Ootel lepingud",
    "Finished contracts": "Lõppenud lepingud",
    "Contract template": "Lepingu mall",
    "Payment recurrence": "Korduvmakse",
    "Yearly": "Iga aasta",
    "Monthly": "Iga kuu",
    "Trial": "Prooviperiood",
    "Region": "Regioon",
    "Field": "Valdkond",
    "All tasks": "Kõik ülesanded",
    "Todo": "Teha",
    "Not done": "Tegemata",
    "Done": "Valmis",
    "Delayed": "Viibinud",
    "Important": "Tähtis",
    "Extra work": "Lisatöö",
    "I Follow": "Jälgin",
    "Commented": "Kommenteeritud",
    "Tracked time": "Märgitud aeg",
    "Estimated": "Prognoosiga",
    "Recurring task": "Korduvülesanne",
    "Last import": "Viimane import",
    "Period": "Periood",
    "Client search": "Kliendi otsing",
    "Voucher": "Kinkekood",
    "Company status": "Ettevõtte staatus",
    "Deleted": "Kustutatud",
    "All status": "Staatused",
    "Payment gateway": "Maksevärav",
    "All gateways": "Kõik gateway’d",
    "Uku manually": "Arvega",
    "Braintree": "Braintree vahendusel",
    "Plan status": "Paketi staatus",
    "All plans": "Kõik paketid",
    "Paid": "Tasutud",
    "Paid churn": "Chrun maksvast",
    "Trial churn": "Churn trialist",
    "Plan period": "Paketi periood",
    "All periods": "Perioodid",
    "Monthly plan": "Kuine pakett",
    "Yearly plan": "Aastane pakett",
    "Company search": "Ettevõtte otsing",
    "User search": "Kasutaja otsing",
    "Name key search": "Nime otsing",
    "None filter": "Tühista",
    "OK": "Ok",
    "Start date cannot be later than due date": "Algusaeg ei saa olla lõpuajast hilisem",
    "tasks": "ülesannet",
    "task(s) had errors": "ülesandel esines viga",
    "tasks selected": "ülesannet valitud",
    "Postpone": "Lükka edasi",
    "Mark done": "Märgi tehtuks",
    "Hide multiselect": "Peida kuvamine",
    "Delete task(s)": "Kustuta ülesanne",
    "All of the data related to the task will be deleted": "Kõik ülesandega seotud info kustutatakse",
    "Some tasks include other people. Are you sure you want to delete?": "Mõned ülesanded sisaldavad teisi liikmeid. Kas oled kindel, et soovite kustutada?",
    "Time has been tracked to some of the selected activities. Are you sure you want to delete?": "Mõne valitud ülesande puhul on jooksutatud aega. Kas oled kindel, et soovite kustutada?",
    "Time has been tracked to some of the selected activities. Some tasks include other people. Are you sure you want to delete?": "Mõne ülesande puhul on jooksutatud aega. Mõned ülesanded sisaldavad teisi liikmeid. Kas olete kindel, et soovid kustutada?",
    "task(s) were not marked done": "ülesanne(t) ei märgitud tehtuks",
    "Please check if the checklist has been completed or time is entered and they are assigned to you": "Palun kontrolli, kas ülesannetel on checklist linnutatud, aeg sisestatud ja kas need on määratud ainult sulle.",
    "task(s) were not deleted": "ülesannet ei kustutatud",
    "task(s) time was not updated": "ülesande ajakirjeid ei muudetud",
    "Please make sure that you can add time to task": "Ülesandele ei saa soovitud perioodis aega lisada",
    "invoice table row": "arve rida",
    "invoice table row(s) had errors": "arve rida | arve ridu",
    "invoice table row(s) selected": "arvet",
    "Create": "Koosta",
    "Mark paid": "Märgi tasutuks",
    "Send to client": "Saada kliendile",
    "Recalculate": "Arvuta uuesti",
    "Export to {0}": "Ekspordi {0}-sse",
    "Update Status from {0}": "Uuenda staatust {0}-st",
    "Void invoice": "Tühista arve",
    "Delete invoice": "Kustuta arve",
    "Restore invoice": "Taasta arve",
    "Mark unpaid": "Märgi mittetasutuks",
    "Invoices": "Arved",
    "Download to Excel": "Lae Excelisse",
    "Revenue split": "Tulude jagunemine",
    "Tax": "KM",
    "Description": "Kirjeldus",
    "Percent": "Protsent",
    "Integration Id": "ID integratsioonis",
    "Integration Code": "Kood integratsioonis",
    "Name on invoice": "Nimetus arvel",
    "Restore": "Taasta",
    "Archive": "Arhiveeri",
    "Hide": "Peida",
    "Are you sure?": "Kas oled kindel?",
    "Invoice seller": "Arve müüja",
    "Company name": "Ettevõtte nimi",
    "Address": "Aadress",
    "Company number": "Registrikood",
    "Tax number": "Maksunumber",
    "Bank": "Pank",
    "IBAN": "IBAN",
    "Delete logo": "Kustuta logo",
    "Upload logo file": "Lae üles logo",
    "Max. dimensions 130 x 130 px": "Maksimaalsed mõõtmed 130 x 130 px",
    "Import finished!": "Import lõpetatud!",
    "Failed to import {0} records": "{0} kirje import ebaõnnestus",
    "Download report": "Laadi raport alla",
    "Result: added {0}, updated {1}, skipped {2}, failed to import {3}": "Tulemus: lisatud {0}, uuendatud {1}, ignoreeritud {2}, ebaõnnestunud {3}",
    "Result: added {0}, updated {1}, skipped {2}": "Tulemus: lisatud {0}, uuendatud {1}, ignoreeritud {2}",
    "What’s next?": "Mis edasi?",
    "To work effectively with your client base, complete the following steps:": "Tõhusaks kliendibaasiga töötamiseks tee järgmised sammud:",
    "Read more ›": "Loe lähemalt ›",
    "Next you will only see active imported clients. To see all clients, remove “Last import” filter.": "Järgmiseks näed ainult aktiivseid imporditud kliente. Kõigi klientide nägemiseks eemalda “Viimane import” filter.",
    "View clients": "Vaata kliente",
    "Add <b>primary member</b> to every client.": "Lisa igale kliendile <b>peakasutaja</b>.",
    "Add <b>task plan</b> to automate recurring tasks.": "Koosta <b>ülesannete mall</b> korduvate tööde automatiseerimiseks.",
    "Setup automatic monthly summary under {0} app in Uku to import volume of work.": "Töömahtude importimiseks seadista {0} rakenduses automaatne kuukokkuvõte",
    "Title": "Pealkiri",
    "Field type": "Välja tüüp",
    "Field name": "Välja nimetus",
    "Client section": "Kliendi osa",
    "Choices": "Valikud",
    "Type each choice on a separate line": "Alusta iga valikut uuelt realt",
    "Required": "Kohustuslik",
    "For all topics": "Kõigile teemadele",
    "For specific topics": "Valitud teemadele",
    "Topics": "Teemad",
    "Non-billable": "Mitte arveldatav",
    "Edit task custom field": "Muuda ülesande lisavälja",
    "Add task custom field": "Lisa ülesande lisaväli",
    "Edit client custom field": "Muuda kliendi lisavälja",
    "Add client custom field": "Lisa kliendi lisaväli",
    "Choice {0}": "Valik {0}",
    "Are you sure that you want to delete this custom field?": "Kas oled kindel, et soovid lisavälja kustutada?",
    "Warning!": "Hoiatus!",
    "This custom field is in use. Do you wish to archive it?": "Lisaväli on kasutusel. Kas soovite arhiveerida?",
    "Reconnect": "Ühenda uuesti",
    "Send test email": "Saada testkiri",
    "Email address or username": "E-posti aadress või kasutajatunnus",
    "Other": "Muu",
    "Set default email server for company": "Määra ettevõtte vaikeserveriks",
    "My default email": "Minu vaikimisi aadress",
    "Depends on": "Seos (eelnev)",
    "Todo - Blocking": "Teha - Blokeeritud",
    "In progress - Blocking": "Töös - Blokeeritud",
    "In progress": "Töös",
    "Client code": "Kliendikood",
    "Primary user": "Vaikimisi kasutaja",
    "Added date": "Lisatud",
    "Updated": "Uuendatud",
    "Contract count": "Lepingute arv",
    "Integration": "Integratsioon",
    "No data available": "Andmed puuduvad",
    "No results found": "Tulemusi ei leitud",
    "Loading": "Laen andmeid",
    "Sort by": "Sorteeri",
    "{0}-{1} of {2}": "{0}-{1} {2}-st",
    "Rows per page": "Ridu lehel",
    "Ongoing": "Töös",
    "important": "tähtis",
    "Read more": "Loe lähemalt",
    "Add to previous time entry": "Lisa eelmisele ajakirjele",
    "Add to next time entry": "Lisa järgmisele ajakirjele",
    "Add new task": "Lisa uus ülesanne",
    "Cut previous time entry": "Lõika eelmine ajakirje",
    "Cut next time entry": "Lõika järgmine ajakirje",
    "Missing time entry": "Puuduv ajakirje",
    "Overlapping time entries": "Kattuvad ajakirjed",
    "Member from custom fields": "Kasutaja lisaväljalt",
    "Delegated to": "Delegeeritud",
    "Delegated by": "Delegeerija",
    "Visible members": "Nähtavad kasutajad",
    "Member type": "Kasutaja tüüp",
    "Groups": "Grupid",
    "Custom field": "Lisaväli",
    "Contact search": "Kontakti otsing",
    "Task start": "Ülesande algus",
    "Task due": "Ülesande tähtaeg",
    "Task finish": "Ülesande lõpetamisel",
    "Custom date": "Vali kuupäev",
    "Never": "Mitte kunagi",
    "Referral status": "Soovituskirja staatus",
    "Invited": "Kutsutud",
    "Registered": "Registreeritud",
    "Earned": "Teenitud",
    "Agreed work is still expected": "Kokkulepitud tunnid on ikka veel eeldatud",
    "Accepted flextime": "Flextime kinnitatud",
    "Declined flextime": "Flextime tagasi lükatud",
    "Cancelled flextime": "Flextime tühistatud",
    "Updated flextime": "Flextime muudetud",
    "Calendar deleted": "Puhkus kustutatud",
    "Calendar created": "Puhkus loodud",
    "Calendar approved": "Puhkus kinnitatud",
    "Calendar declined": "Puhkus tagasi lükatud",
    "Calendar updated": "Puhkus muudetud",
    "Flextime balance updated": "Ületundide saldo muudetud",
    "Flextime": "Flextime",
    "Vacation": "Puhkus",
    "Balance": "Vahe",
    "Comment": "Kommenteeri",
    "History": "Ajalugu",
    "Action": "Tegevus",
    "Who": "Kes",
    "Take a vacation or mark an absence": "Märgi puhkus või eemalolek",
    "Away": "Eemal",
    "Flextime bonus": "Flextime boonus",
    "Approver": "Kinnitaja",
    "Vacation available": "Puhkusejääk",
    "Type": "Tüüp",
    "Reduce agreed working hours": "Vähenda kokku lepitud töötunde",
    "Reject": "Lükka tagasi",
    "Approve": "Kinnita",
    "away_type_Away": "Eemal",
    "Sick leave": "Haigus/hooldus",
    "Parental leave": "Vanemapuhkus",
    "Working hours": "Tööaeg",
    "Mon-Fri, 40h weekly, 8h daily": "E-R, 40h nädalas, 8h päevas",
    "Customize": "Kohanda",
    "Total": "Kokku",
    "Settings": "Seaded",
    "Work on holidays": "Arvesta riigipühi tööajana",
    "Get {0} in cash for every referral who becomes a Uku client.": "Saa {0} iga uue Uku kliendi soovituse eest.",
    "Copy your invite link": "Kopeeri oma kutse link",
    "Hide message": "Peida sõnum",
    "View message": "Vaata sõnumit",
    "Your statistics": "Teie statistika",
    "Copy message": "Kopeeri sõnum",
    "How it works": "Kuidas see töötab",
    "Invite your friends to Uku, and we'll give a free month of Uku - and show them how to boost their business.": "Kutsu oma sõbrad Uku’t kasutama ja me anname neile ühe kuu tasuta ning tasuta tiimi koolituse, et aidata neil oma äri veelgi paremini juhtida.",
    "After your referral becomes a paying Uku client, we send you a {0} gift card.": "Pärast seda, kui sinu soovitatud sõber saab Uku maksvaks kliendiks, saadame sulle {0} kinkekaardi.",
    "More ways to earn cash": "Veel võimalusi aitamiseks",
    "referral_email_content": "Hei, {{friend_name}}!<br><br>Ise kasutan ja usun, et Sulle ka meeldiks kasutada Uku kaasaegset tööhalduse ja CRM tarkvara. Toon välja mõned tugevused, mida kasutan:<br>* Ülesannete automatiseerimine – töötab nagu isiklik assistent<br>* Tööaja arvestus – lihtsam ja täpsem kui Toggl<br>* Kliendihaldus – kõik vajalik info ühes kohas<br>* Arvete koostamine – automaatne ja kiire<br>* Kliendikokkulepete monitooring – hoiab kõik kokkulepped kontrolli all<br><br>Minu soovitusega kingitakse sulle 30-päevane tasuta prooviperiood ja tasuta tiimi treening. Võid siit lähemalt lugeda: {{learn_more_link}}<br><br>{{accept_invite_link}} (Võtan kutse vastu)<br><br>Parimate soovidega<br>{{your_name}}",
    "Write feedback for Uku and get <a href='/api/help_link/referral_feedback' target='_blank'>{0} gift card here</a>": "Kirjuta Uku kohta tagasiside ja saa <a href='/api/help_link/referral_feedback' target='_blank'>{0} kinkekaart siit</a>",
    "Expand": "Ava",
    "Wait until event status": "Oota, kuni event staatus on",
    "Wait until project status": "Oota projekti staatust",
    "Week(s)": "Nädal(at)",
    "Day(s)": "Päev(a)",
    "Rule": "Reegel",
    "Depends on event": "Sõltub sündmusest",
    "Depends on project": "Sõltuvalt",
    "Due date in": "Tähtaeg",
    "Status": "Staatus",
    "Select event": "Vali sündmus",
    "Select project": "Vali projekt",
    "Find event...": "Otsin sündmust…",
    "Find project...": "Otsi projekti…",
    "Custom recurrence": "Seadista oma korduvus",
    "Every": "Iga",
    "In case of holiday": "Kui tegemist on puhkepäevaga, siis",
    "Set time": "Kell",
    "Start time": "Alguse kellaaeg",
    "Repeat from": "Kordub alates",
    "Previous repeat from: {0}": "Praegu kordub alates {0}",
    "On date": "Kuupäev",
    "Plus days": "+ päeva",
    "Due date time": "Lõpu kellaaeg",
    "Remove recurrence": "Eemalda korduvus",
    "Repeat": "Korduvus",
    "month": "kuu",
    "quarter": "kvartal",
    "year": "aasta",
    "1st month": "1. kuu",
    "2nd month": "2. kuu",
    "3rd month": "3. kuu",
    "Day {0}": "Päev {0}",
    "Show before": "Kuva enne",
    "Keep the day": "Jäta samaks",
    "Show after": "Kuva pärast",
    "From start date": "Alguskuupäevast",
    "From beginning of the month": "Kuu algusest",
    "All days (Mon to Sun)": "Kõik päevad (E - P)",
    "Mon to Fri (incl. holidays)": "Tööpäevad (k.a pühad)",
    "Mon to Fri (excl. holidays)": "Tööpäevad (v.a pühad)",
    "1st": "1.",
    "2nd": "2.",
    "3rd": "3.",
    "Does not repeat": "Korduvus puudub",
    "Daily": "Iga päev",
    "Weekly on {0}": "Iga nädal {0}",
    "Monthly on day {0}": "Iga kuu {0}",
    "Quarterly on {0} month {1} day": "Iga kvartal {0} kuu {1} kp",
    "Yearly on {0} {1}": "Iga aasta {0} {1}",
    "Custom...": "Seadista oma korduvus",
    "Incorrect time": "Vale aeg",
    "Add repeat": "Lisa korduvus",
    "Email added to queue": "E-kiri lisatud järjekorda",
    "Communication timeline": "Suhtluse ajajoon",
    "Activate Email App in App Store to send automated emails and view your past and future communication in one place.": "Aktiveeri e-kirjade äpp seadete ja rakenduste all, et saata automatiseeritud e-kirju ja näha saadetud ja planeeritud kirju ühes kohas ",
    "Go to App Store": "Seadista rakendus",
    "Unknown": "Tundmatu",
    "<b>Email</b> from": "<b>E-kiri</b> saatjalt",
    "To": "saajale",
    "Planned": "Planeeritud",
    "Automated emails scheduled to be sent in the future": "E-kirjad, mis saadetakse järgmise 45 päeva jooksul",
    "Send e-mail": "Saada e-kiri",
    "Template unlinked": "Mall lahti ühendatud",
    "Icon": "Ikoon",
    "Link name": "Lingi nimi",
    "Link URL": "Lingi URL",
    "Open in new tab": "Ava uuel kaardil",
    "Visible": "Nähtav",
    "External": "Väline",
    "Not external": "Ei ole väline",
    "Company default": "Ettevõtte vaikimisi",
    "Not visible": "Ei ole nähtav",
    "Use company default": "Kasutage ettevõtte vaikimisi",
    "or choose icon": "või valige ikoon",
    "Find member...": "Otsi kasutajat...",
    "I'll take it": "Võtan endale",
    "Remove me": "Eemalda mind",
    "Remove from task": "Eemalda ülesandelt",
    "Learn more": "Loe rohkem",
    "Company settings edit is disabled by owner": "Ettevõtte seaded on omaniku poolt lukustatud",
    "<b>Exported</b> {0} to {1}": "<b>Eksporditud</b> {0} {1}-sse",
    "<b>Sent to client</b> {0} from {1}": "<b>Saadetud kliendile</b> {0} aadressilt {1}",
    "<b>Paid {0}</b> {1}": "<b>Makstud {0}</b> {1}",
    "<b>Annulled</b> {0}": "<b>Tühistatud</b> {0}",
    "Do you wish to mark the task done for everyone?": "Kas soovid kõigil töö tehtuks märkida?",
    "No, remove me": "Ei, eemalda mind",
    "Task won’t be marked done, but user is removed from the assignees and added to the followers of the task": "Tööd ei märgita tehtuks, aga kasutaja eemaldatakse töö tegijate seast ja lisatakse jälgijate hulka.",
    "Invalid email": "Vigane e-post",
    "Accounting": "Raamatupidamine",
    "General": "Üldine",
    "Advertising / Marketing/ PR": "Reklaam / Turundus / PR",
    "Architecture": "Arhitektuur",
    "Construction": "Ehitus",
    "Consulting - IT, software": "Konsultatsioon - IT, tarkvara",
    "Consulting - Management": "Konsultatsioon - Juhtimine",
    "Finance": "Finantsteenused",
    "Legal": "Õigus",
    "Medicine / Pharmacy ": "Meditsiin / Farmaatsia",
    "Non-profit": "Mittetulundus",
    "Web design": "Veebidisain",
    "Web development": "Veebiarendus",
    "Max 140 characters": "Maksimaalselt 140 tähemärki",
    "Please complete the checklist": "Palun linnutage checklist",
    "It is required to mark all checklist items as done": "Checklist peab olema linnutatud ülesande lõpetamiseks",
    "Please enter time spent": "Palun märgi ka kulunud aeg",
    "Inserting time is essential for this client": "Palun sisesta aeg",
    "Only me": "Ainult mulle",
    "Private": "Isiklik",
    "Edit note": "Muuda märget",
    "Add additional information about the client, such as special agreements, passwords, etc.": "Lisa vajalik teave kliendi kohta, näiteks kokkulepped, salasõnad jm.",
    "Edit": "Muuda",
    "Workdays": "Tööpäevi",
    "Workhours": "Töötunde",
    "Weeks": "Nädalad",
    "Clear filters": "Tühjenda filter",
    "Save filters": "Salvesta filtrivalikud",
    "Expected": "Oodatud",
    "Estimation": "Prognoos",
    "Do you also want to postpone the due date?": "Kas soovid ka tähtaega muuta samale kuupäevale?",
    "{0} week": "{0} nädal",
    "{0} weeks": "{0} nädalat",
    "Vacations": "Puhkused",
    "Holidays": "Riigipühad",
    "Tax dates": "Maksutähtajad",
    "Accounting news": "Uudised",
    "Company events": "Ettevõtte sündmused",
    "Member birthdays": "Kasutajate sünnipäevad",
    "Contact birthdays": "Kontaktide sünnipäevad",
    "Group items": "Grupeeri kui mitu",
    "Don't group": "Ära grupeeri",
    "{0} away": "{0} eemal",
    "Member birthday | Member birthdays": "Kasutaja sünnipäev | Kasutajate sünnipäevad",
    "Contact birthday | Contact birthdays": "Kontakti sünnipäev | Kontaktide sünnipäevad",
    "Contact birthday": "Kontakti sünnipäev",
    "Member birthday": "Kasutaja sünnipäev",
    "Are you sure you wish to delete this link?": "Kas oled kindel, et soovid lingi kustutada?",
    "Reference name": "Viite nimi",
    "Reference link": "Viite link",
    "Free trial": "Prooviperiood",
    "Solo": "Solo",
    "Team": "Team",
    "Enterprise": "Enterprise",
    "Mini Uku": "Mini Uku",
    "Chrome browser plugin for Uku to manage your task, clients and track time.": "Uku Chrome'i plugin ülesannete ja klientide haldamiseks ning aja mõõtmiseks.",
    "Setup task/job plans to automate your workflow, add topics, custom fields and modify your preferences.": "Loo mallid töö automatiseerimiseks, lisa teemad, lisaväljad ning määra enda ettevõtte seadistused",
    "Setup client groups, custom fields and modify your preferences.": "Seadista kliendigrupid, kliendi väljad ning määra enda ettevõtte seadistused",
    "test": "test",
    "Anti Money Laundering": "Rahapesu tõkestamine",
    "Setup your customer AML and get instant reminders when auditing is due.": "Seadista kliendi rahapesu tõkestamise protsess ning saa teavitusi, mil andmed vajavad uuendamist.",
    "flextime_description": "Mugav ja ülevaatlik töötundide ja puhkuste arvestus.",
    "Smart Accounts": "Smart Accounts",
    "Automatically imports work statistics from your accounting software.": "Impordib automaatselt andmed sinu raamatupidamisprogrammist.",
    "Merit Aktiva": "Merit Aktiva",
    "360 Księgowość": "360 Księgowość",
    "Speed up your client billing process with pricelists and smart contracts.": "Muuda ettevõtte arveldamine kiiremaks tarkade hinnakirjade ning lepingutega.",
    "Visual report will tell you exactly how profitable or unprofitable your client is.": "Visuaalne raport annab ülevaate kui kasumlik on klient.",
    "Emailing description": "Automatiseeri korduvad kirjad ja saada klientidele e-kirju otse Ukust",
    "e-conomic": "e-conomic",
    "Sync client data from Uku to e-conomic and vice versa. View sales ledger information for each client.": "Impordi kliendid ja automatiseeri arveldamine. Saada kõik arved e-conomicusse vaid nelja klikiga.",
    "Xero": "Xero",
    "xero_description": "Impordi kliendid mugavalt Ukusse ja automatiseeri arveldamine.",
    "QuickBooks": "QuickBooks",
    "quickbooks_description": "Impordi kliendid mugavalt Ukusse ja automatiseeri arveldamine.",
    "Tripletex": "Tripletex",
    "tripletex_description": "Impordi kliendid mugavalt Ukusse ja automatiseeri arveldamine.",
    "Scoro": "Scoro",
    "Export sales invoices.": "Ekspordi müügiarved.",
    "Fortnox": "Fortnox",
    "fortnox_description": "Impordi kliendid mugavalt Ukusse ja automatiseeri arveldamine.",
    "Magic button": "Ülesande kiirvalikud",
    "With one click - a quick and easy way to create important tasks. For example, a phone call from a client.": "Loo uus ülesanne ühe klikiga ja alusta ajamõõtmist. Nii saad mugavalt vahele tulevad ülesanded Ukusse sisestada.",
    "With suppliers, you make your projects and partners management more efficient.": "Kasutades tarnijaid, teed oma projektide ja koostööpartnerite haldamise efektiivsemaks.",
    "Powerful and flexible project management serves diverse use cases and workflows.": "Paindlik ja võimekas projektijuhtimise tööriist, mis sobib paljude kasutusjuhtude ja protsesside juhtimiseks.",
    "client_portal_app_description": "Kliendiportaal lihtsustab koostööd klientidega - võta turvaliselt vastu dokumente, suuna ülesandeid ja jaga olulist teavet.",
    "Chat": "Vestlus",
    "chat_app_description": "Mugav kommunikatsiooni tööriist, mis lihtustab suhtlust meeskonnaliikmete ja klientidega.",
    "Companies House": "Companies House",
    "companies_house_app_description": "Seadista Companies House väljad ja automaatsed protsessid Ühendkuningriigi klientidele.",
    "documents_app_description": "Automaatselt sünkroniseeri kõik failid enda dokumendihoidlasse.",
    "FreeAgent": "FreeAgent",
    "freeagent_description": "Impordi klientide andmed tarkvarast Freeagent.",
    "Trigon": "Trigon",
    "trigon_description": "trigon_description",
    "Connect and discover tools to help you manage your business.": "Avasta tööriistad oma ettevõtte töö juhtimiseks.",
    "Subscribe now": "Vali pakett",
    "Compare plans": "Võrdle pakette",
    "Add company": "Lisa ettevõte",
    "BETA": "BETA",
    "Setup": "Seadistused",
    "Power up": "Rakendused",
    "Integrations": "Integratsioonid",
    "Hi! Do you want to work with a team and use extra features? No problem, first add your company!": "Hei! Soovid töötada tiimis ja kasutada lisavõimalusi? Lisa selleks enda ettevõte!",
    "Read more about Uku plans": "Loe pikemalt Uku pakettide kohta",
    "Contact role": "Kontakti roll",
    "Contact roles": "Kontakti rollid",
    "Client groups": "Kliendigrupid",
    "Client fields": "Kliendi väljad",
    "Contact fields": "Kontakti väljad",
    "View archive": "Vaata arhiivi",
    "Restore from archive": "Taasta arhiivist",
    "Empty list": "Tühi nimekiri",
    "Task fields": "Lisaväljad",
    "task topics": "teemat",
    "Keep the task opened when starting the timer": "Jäta timeri käivitamisel ülesanne avatuks",
    "task templates": "tööde mall",
    "Author": "Omanik",
    "Duplicate": "Duplitseeri",
    "Uku task templates": "Uku ülesandemallid",
    "Are you sure that you want to delete this task template?": "Kas oled kindel, et soovid malli kustutada?",
    "Templates": "Mallid",
    "Overview": "Ülevaade",
    "chat_app_overview_text": "<p class='title'>Uku Sõnumid on kasutajasõbralik ja turvaline kommunikatsiooni tööriist, millega on koostöö tiimi ja klientidega imelihtne.</p> <div class='body-2'><p>Rakenduse põhifunktsioonid:</p><ul><li>Reaalajas sõnumid - Saada meeskonnaliikmetele ja klientidele otsesõnumeid või suhtle grupivestluste vahendusel.</li><li>Ülesannete haldus - Loo vestlusest uus ülesanne.</li><li>ChatGPT integratsioon - Tee vestlusest kokkuvõte, muuda suhtlusstiili ja küsi vastamiseks soovitusi.</li><li>Kohandatavad teavitused - Kohanda teavitused vastavalt oma eelistustele.</li></ul></div>",
    "Color": "Värv",
    "Are you sure to delete this field? You may lose the data.": "Kas oled kindel, et soovid välja kustutada?",
    "Add field": "Lisa uus väli",
    "Add section": "Lisa vahepealkiri",
    "multiline": "mitu rida",
    "Import": "Impordi",
    "Import data": "Andmete import",
    "Automate data collection with Smart Accounts": "Automaatne andmete kogumine Smart Accounts programmiga",
    "<ul><li>Import purchase and sales entries, total entries and entry lines count;</li><li>Automate data collection with Smart Accounts;</li><li>Faster & more accurate billing through automated data exchange. Uku gathers information for preparing customers' invoices in one place and makes invoicing efficient.</li></ul>": "<ul><li>Impordi ostu- ja müügiarved, kanded ning kirjed;</li><li>Automatiseeri andmete kogumine programmiga Smart Accounts;</li><li>Kiirem ja täpsem arveldamine läbi automatiseeritud andmevahetuse. </li></ul>",
    "xero_app_overview_text": "<p class='title'>Ühenda Xero Ukuga ja automatiseeri arveldamine.</p><div class='body-2'><p>Xero integratsiooniga:</p><p><ul><li>impordi kliendid Ukusse mõne klikiga</li><li>impordi tootekoodid ja klassifikaatorid</li><li>seadista automaatne arveldamine ja saada arved Xerosse</li></ul><p></div>",
    "Import clients from {0}": "Impordi kliendid allikast {0}",
    "Before importing clients, you need to authorize with Xero and select the Company.": "Klientide importimiseks pead esmalt Uku siduma Xero-ga.",
    "Authorize Xero to start import": "Luba Xerol alustada importi",
    "Failed to import clients": "Klientide import ebaõnnestus",
    "Failed to connect to WS": "Ühenduse loomine web socketiga ebaõnnestus",
    "emailing_app_overview_text": "<p class='title'><b>Mugavam ja kiirem kirjavahetus</b></p><div class='body-2'><p>Saada ühekordseid e-kirju või seadista automaatne saatmine. Mõlemat tegevust saad teha ülesande vaatest.</p><p><b>Automatiseeri meeldetuletuskirjad</b></p><p>Lisa korduvale ülesandele e-kiri, mis saadetakse välja Sinu eest. Näiteks seadista ülesandele “Dokumentide sisestus” automaatne kiri “Puuduvad dokumendid”, mis saadetaks välja 2 päeva enne ülesande algust. Nii on tööd alustades kliendilt dokumendid käes.</p><p><b>E-kirjade mallid</b></p><p>Salvesta e-kirjad, mida sageli saadad, mugavalt malliks. See säästab Sind sama sisuga kirjade pideva koostamise vaevast.</p></div>",
    "Email signatures": "E-posti allkirjad",
    "Everyone": "Kõigile",
    "Access": "Nähtav",
    "Creator": "Lisaja",
    "Are you sure you want to delete this signature? Some emails will be affected": "Kas olete kindel, et soovite selle allkirja kustutada? See mõjutab mõningaid e-kirju",
    "Email addresses": "E-posti aadressid",
    "Signatures": "Signatuurid",
    "Send emails": "Saada e-kirju",
    "Uku securely integrates with your email to help you manage and automate communication": "Uku ühendub turvaliselt su e-postiga, et hallata ja automatiseerida suhtlust",
    "Use {0} address": "Kasuta {0} aadressi",
    "connect your email address": "Ühenda oma e-posti aadress",
    "Connect with Microsoft Exchange or other email server(SMTP)": "Ühenda Microsoft Exchange’i või mõne teise e-posti serveriga (SMTP)",
    "Email integration reconnected": "Ühendus e-posti serveriga taastatud",
    "Are you sure you want to delete this email integration?": "Kas oled kindel, et soovid e-posti ühenduse eemaldada?",
    "Email templates": "E-kirja mallid",
    "Add email template": "Lisa e-kirja mall",
    "Are you sure you want to save this template? Some tasks will be affected": "Kas oled kindel, et soovid malli salvestada? Mõned ülesanded on sellega seotud",
    "Clients can leave task messages by replying to client portal email": "Kliendid saavad jätta ülesande sõnumeid, vastates kliendiportaali e-kirjale",
    "Send a copy of client's response to member's inbox": "Saada kliendi vastuse koopia liikme postkasti",
    "Email recipients can leave task comments by replying to a task email": "E-posti saajad saavad jätta ülesande kommentaarid, vastates ülesande e-kirjale",
    "economic_app_overview_text": "<p class='title'>Ühenda e-conomic Ukuga, et automatiseerida arveldamine.</p><div class='body-2'><p>e-conomicu integratsiooniga:<ul><li>impordid kõik oma kliendid e-conomicust mõne klikiga;</li><li>impordid tooted ja klassifikaatorid e-conomicust;</li><li>koostad Ukus automaatselt arved ja saadad need e-conomicusse.</li></ul></p></div>",
    "Default layout": "Vaikimisi küljendus",
    "Change agreement ID": "Muuda lepingu ID-d",
    "Failed to connect to server": "Serveriga ühendumine ebaõnnestus",
    "Uku will import all clients, clients info and classificatiors. In the final step you can select which clients you want to add or update.": "Uku impordib kõik kliendid, klientide info ja klassifikaatorid. Viimases sammus saad valida, milliseid kliente lisada või uuendada.",
    "Connect e-conomic": "Ühenda e-conomic",
    "Before importing clients, you need to connect Uku and economic software. To do this, create economic agreement and enter the agreement ID here.": "Klientide importimiseks pead esmalt Uku siduma e-conomicuga. Selleks loo e-conomicu lepingu ID ja sisesta see siia.",
    "Step {0}": "Samm {0}",
    "Get agreement ID": "Hangi lepingu ID",
    "Insert agreement ID": "Sisesta lepingu ID",
    "Connect": "Ühenda",
    "quickbooks_app_overview_text": "<p class='title'>Ühenda QuickBooks Ukuga ja automatiseeri arveldamine.</p><div class='body-2'><p>QuickBooks integratsiooniga:</p><p><ul><li>impordi kliendid Ukusse mõne klikiga</li><li>impordi tootekoodid ja klassifikaatorid</li><li>seadista automaatne arveldamine ja saada arved QuickBooksi</li></ul><p></div>",
    "Uku will import all clients, clients info and classificatiors from QuickBooks. In the final step you can select which clients you want to add or update.": "Uku impordib QuickBooks-st kõik kliendid, kontaktid ja arveldamiseks vajalikud tooted/teenused. Impordi viimases sammus saad valida, milliseid kliente lisada või uuendada.",
    "Before importing clients, you need to connect with QuickBooks.": "Klientide importimiseks pead esmalt Uku siduma QuickBooks-ga.",
    "Connected to QuickBooks": "Ühendatud QuickBooks-ga",
    "fortnox_app_overview_text": "<p class='title'>Ühenda Fortnox Ukuga ja automatiseeri arveldamine.</p><div class='body-2'><p>Fortnox integratsiooniga:</p><p><ul><li>impordi kliendid Ukusse mõne klikiga</li><li>impordi tootekoodid ja klassifikaatorid</li><li>seadista automaatne arveldamine ja saada arved Fortnoxi</li></ul><p></div>",
    "Uku will import all clients, clients info and classificators from Fortnox. In the final step you can select which clients you want to add or update.": "Uku impordib Fortnox-st kõik kliendid, kontaktid ja arveldamiseks vajalikud tooted/teenused. Impordi viimases sammus saad valida, milliseid kliente lisada või uuendada.",
    "Before importing clients, you need to connect with Fortnox.": "Klientide importimiseks pead esmalt Uku siduma Fortnox-ga.",
    "Connect to Fortnox": "Ühendu Fortnox-ga",
    "Connected to Fortnox": "Ühendatud Fortnox-ga",
    "Delete template": "Kustuta mall",
    "Public": "Kõigile",
    "Workflow templates": "Tööplaani mallid",
    "No workflow templates yet": "Tööplaani malle pole veel",
    "Modified": "Muudetud",
    "Uku workflow templates": "Uku tööplaanide mallid",
    "Are you sure you wish to delete this workflow?": "Kas oled kindel, et soovid tööplaani kustutada?",
    "Project fields": "Projekti väljad",
    "Progress step": "Projekti faas",
    "Rename project": "Nimeta projekt ümber",
    "Project statuses": "Projekti staatused",
    "You can use the statuses to restrict the workflow.": "Kasuta staatuseid, et töövooge paremini hallata.",
    "Project phases": "Projekti faasid",
    "Make your progress beautiful.": "Visualiseeri projekti kulgu!",
    "Permissions": "Õigused",
    "Users can manage workflow templates": "Kasutajad saavad muuta projekti tööplaani malle",
    "project_app_overview_text": "Juhi projekti kogu elutsükli vältel.",
    "project_app_overview_description": "<div class='body-2'><p>Projektide planeerimine, elluviimine ja jälgimine Ukuga on lihtne.</p><p>Uku projektide peamised funktsionaalsused:</p><ul><li><b>Projekti lisamine: </b>Loo projekt, kasutades süsteemseid ning muudetavaid projekti töövoo malle või loo enda ettevõttele sobilikud mallid. Hoia raamatupidamisest erinev töö, nagu näiteks uue kliendi või töötaja lisandumine, eraldi igapäevastest ülesannetest. </li><li><b>Ülesannete haldamine: </b>Jaga projekt ülesanneteks, määra vastutajad, tähtpäevad ja sõltuvused. Erista lisateenused igapäevastest teenustest.</li><li><b>Projekti ülevaade: </b>Jälgi projekti edenemist, blokeeritud ja sõltuvate ülesannete seisu jpm, et hallata projekti kulgu ja ennetada hilinemist. Projekti ülesandeid kuvatakse tavaülesannetest erinevalt, et hõlbustada projektide haldamist. </li><li><b>Kohandatavus: </b>Lisage välju ja kohandage töövooge lähtudes oma organisatsiooni vajadustest. Pane ülesanded sõltuma projekti algusest või lõpust, et tuua painduvust projekti haldamisse. </li></ul></div>",
    "Configure summary task": "Seadista ülesanne töömahtude kokkuvõttele",
    "Uku will generate task with following title and topic on the last day of the month.": "Uku loob ülesande järgneva pealkirja ja teemaga kuu viimasele päevale.",
    "Task title": "Ülesande pealkiri",
    "Recurrence": "Korduvus",
    "First import start date": "Esimene impordi kuupäev",
    "Count changes from previous periods": "Pea arvet muudatuste üle varasemates perioodides",
    "If enabled, changes made to previous periods will be added to current month. If disabled, changes made to previous periods will not be accounted for.": "Lülita sisse, kui soovid varasematesse perioodidesse hiljem lisatud töömahtusid võtta arvesse jooksvas kuus. Vastasel juhul kajastatakse töömahud kande kuupäeva järgi.",
    "Automatically finish summary tasks": "Automaatselt lõpeta kokkuvõtvad ülesanded",
    "If enabled, summary tasks will be created as finished.": "Juhul kui valitud, siis kokkuvõttev ülesanne luuakse lõpetatud staatuses.",
    "Configure data fields": "Seadista andmeväljad",
    "Select corresponding Uku field for each imported field. Same fields will be summarized. By leaving some field blank it will be ignored.": "Vali imporditavatele väljadele sobivad Uku väljad. Samad väljad summeeritakse. Jättes välja tühjaks, seda ignoreeritakse.",
    "New custom field": "Uus lisaväli",
    "Show more": "Näita rohkem",
    "Every month": "Iga kuu",
    "Last work day of the month": "Kuu viimane tööpäev",
    "Last day of the month": "Kuu viimasel päeval",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "11",
    "12": "12",
    "13": "13",
    "14": "14",
    "15": "15",
    "16": "16",
    "17": "17",
    "18": "18",
    "19": "19",
    "20": "20",
    "21": "21",
    "22": "22",
    "23": "23",
    "24": "24",
    "25": "25",
    "26": "26",
    "27": "27",
    "28": "28",
    "Day {0} of next month": "Järgmise kuu {0}. päev",
    "Settings saved": "Seaded salvestatud",
    "Uku will let you know when it is ready.": "Uku annab Sulle märku kui töömahtude kokkuvõtted on imporditud",
    "Reload data": "Impordi töömahud kohe",
    "months": "kuud",
    "This will overwrite existing summary tasks new values.": "Selle tegevusega kirjutatakse kõigi seniste töömahte kokku võtvate ülesannete kanded-dokumendid üle värskete andmetega. Varasematesse perioodidesse hiljem lisatud andmed kajastatakse nüüd sisestamise perioodi asemel kande perioodis.",
    "Overwrite": "Kirjuta üle",
    "trigon_app_overview_text": "trigon_app_overview_text",
    "Uku will import all clients and their info from Trigon. In the final step you can select which clients you want to add or update.": "Uku impordib kõik kliendid ja nende info Trigonist. Viimases vaates saad valida, millised kliendid soovid lisada või uuendada.",
    "Connect Trigon": "Ühenda Trigon",
    "Before importing clients, you need to connect Uku and Trigon software. To do this, enter your credentials here.": "Enne klientide importi on tarvis ühendada Uku ja Trigoni tarkvarad. Selleks sisesta enda andmed siia.",
    "Insert email and password": "Sisesta e-mail ja salasõna",
    "Automate your anti money laundering process": "Automatiseeri rahapesu tõkestamise protsess",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Profile valid until</il><li>AML Staus</il><li>Document NO</il><li>Document valid until</li></ul>": "Oled aktiveerimas rahapesu tõkestamise protsessi. Sinu ettevõtte klientidele lisatakse uued kliendi lisaväljad ning süsteem hakkab sind nende uuendamisest teavitama.<br><br>Lisaväljad on:<ul><li>Riskiprofiil</il><li>Profiil kehtiv</il><li>Ankeedi staatus</il><li>Dokumendi NR</il><li>Dokument kehtiv</li></ul>",
    "You are about to activate anti money laundering process. During that new additional fields will be added to your clients data and also system will start reminding you about updating them.<br><br>Additional fields are:<ul><li>Risk profile</il><li>Next AML check</il><li>Pass/Fail</il><li>ID type</il><li>ID Number</il><li>Date of expiry</il><li>Additional checks</li></ul>": "Oled aktiveerimas rahapesu tõkestamise protsessi. Sinu ettevõtte klientidele lisatakse uued kliendi lisaväljad ning süsteem hakkab sind nende uuendamisest teavitama.<br><br>Lisaväljad on:<ul><li>Riskiprofiil</il><li>Profiil kehtiv</il><li>Ankeedi staatus</il><li>Dokumendi NR</il><li>Dokument kehtiv</li></ul>",
    "Do not change client custom fields created by Uku": "Luuakse Uku poolt loodud kliendi lisavälja põhjal",
    "day(s) before": "päev(a) enne",
    "Task name": "Ülesande pealkiri",
    "Assigned": "Kasutaja",
    "Note": "Kirjeldus",
    "Manual run": "Käivita manuaalselt",
    "Create a task when the document expires": "Loo ülesanne dokumendi kehtivuse lõppedes",
    "Create a task when the risk profile must be updated": "Loo ülesanne riskiprofiili kehtivuse lõppedes",
    "Flextime period": "Flextime periood",
    "Confirmation period": "Kinnitusperiood",
    "Weekly": "Iga nädal",
    "Add agreement": "Lisa kokkulepe",
    "flextime_app_overview_text": "<p class='title'>Põhjalik ülevaade meeskonna tööajast, ületundidest ja puhkuste jäägist.</p><div class='body-2'><p>Flextime’i kasutegurid:</p><p><ul><li>Mugav töö- ja ületundide arvestus</li><li>Ülevaade puhkustest ja selle jäägist</li><li>Ühe klikiga allalaetav raport raamatupidajale</li></ul><p></div>",
    "supplier_app_overview_text": "Halda oma tarnijaid ja koostööpartnereid.",
    "supplier_app_overview_description": "<div class='body-2'><p>Halda Ukus oma koostööpartnereid, tarnijaid ja teisi kontakte, kes ei ole su kliendid.</p></div>",
    "Supplier type": "Tarnija tüüp",
    "Parent type": "Baastüüp",
    "Edit supplier type": "Muuda tarnija tüüpi",
    "New supplier type": "Uus tarnija tüüp",
    "Are you sure you wish to delete this supplier type?": "Kas oled kindel, et soovid tarnija tüübi kustutada?",
    "Types": "Liigid",
    "Supplier types": "Tarnijate tüübid",
    "No supplier types yet": "Tarnijate tüüpe pole veel",
    "tripletex_app_overview_text": "<p class='title'>Ühenda Tripletex Ukuga ja automatiseeri arveldamine.</p><div class='body-2'><p>Tripletex integratsiooniga:</p><p><ul><li>impordi kliendid Ukusse mõne klikiga</li><li>impordi tootekoodid ja klassifikaatorid</li><li>seadista automaatne arveldamine ja saada arved Tripletexi</li></ul><p></div>",
    "Uku will import all clients, clients info and classificators from Tripletex. In the final step you can select which clients you want to add or update.": "Uku impordib Tripletex-st kõik kliendid, kontaktid ja arveldamiseks vajalikud tooted/teenused. Impordi viimases sammus saad valida, milliseid kliente lisada või uuendada.",
    "Connect Tripletex": "Ühendu Tripletex-ga",
    "Before importing clients, you need to connect Uku and Tripletex software. To do this, create employee token and enter it here.": "Klientide importimiseks pead esmalt Uku siduma Tripletex-ga. Selleks loo kasutajale ligipääsutunnus Tripletex-s ja sisesta see siia.",
    "Get employee token": "Hangi töötaja ligipääsutunnus",
    "Insert employee token": "Seadista töötaja juurdepääsutunnus",
    "Install": "Aktiveeri",
    "Open Chrome browser to install": "Ava installeerimiseks Chrome.",
    "Works with your online accounting software.": "Töötab Sinu online raamatupidamistarkvaraga.",
    "New tasks can strike like lightning and that’s why Mini Uku is your best friend. No matter whether you’re making bank transfers or working in your accounting software; with Mini Uku you can add new tasks, track time and keep on top of all your notifications from any website.<br><br>Just one click on the owl icon provides an overview of your entire working day and helps you plan your schedule more efficiently.": "Uued ülesanded võivad tulla ootamatult ja seetõttu on Mini Uku Sinu parim kaaslane. Olenemata sellest, kas oled tegemas ülekandeid või töötamas raamatupidamistarkvaras, Mini Ukuga saad lisada uusi ülesandeid, jooksutada aegu, ning jälgida kõiki oma teavitusi igal lehel.",
    "merit_aktiva_app_overview_text_pl": "<p class='title'>Impordi kliendid ja tehtud töö mahud ja saad täieliku ülevaate kõikidele kliendile tehtud töödest.</p><div class='body-2'><p>Muuda oma andmete kogumine 360 Księgowość ja Uku integratsiooni abil kiireks ja täpseks. Uku impordib igale kliendile tehtud töö mahud, näiteks ostu- ja müügiarved, dokumendid, kanded jm. ning koostab ülevaatliku aruande töömahtudest ja kulunud ajast. Enam ei pea käima iga kliendi all eraldi, et saada kokku vajalikud andmed klientidele arvete koostamiseks või töömahu analüüsiks.</p><p>Erinevalt 360 Księgowość, kajastab Uku raport kõiki eelmises kuus tehtud töid, võttes arvesse muudatusi, mis sisestati eelmistesse perioodidesse. See tähendab, et enam ei pea varasemaid sissekandeid meeles pidama, eraldi välja kirjutama või võrdlema perioode - Ukul on kõik see info olemas ja Sinul samuti. Automatiseeritud andmete kogumine hoiab kokku väärtuslikku tööaega ja välistab inimlikud andmesisestusel tekkivad vead.</p><p>Uku ja 360 Księgowość integratsioon aitab Sul:</p><p><ul><li>Kiirelt ja täpselt tehtud töö andmed kokku koguda - töö mahud imporditakse automaatselt 360 Księgowość Ukusse.</li><li>Analüüsida töömahte ja selleks kulunud aega - iga kliendi kohta on täielik ülevaade.</li><li>Automatiseerida igakuisete kokkuvõtete koostamist.</li><li>Saada iga kuu ülevaade tegelikust töömahust</li></ul></p><p>Peale integratsiooni aktiveerimist saad sisse tõmmata ka varasemate perioodide töömahud.</p><p>Uku ja 360 Księgowość integratsiooniga saad importida järgmisi andmeid:</p></p><ul><li>Kannete arv</li><li>Müügi kanded</li><li>Ostu kanded</li><li>Dokumendid (ost ja müük)</li><li>Kanded (v.a. müük)</li><li>Kanded (v.a. pank)</li><li>Kanded (v.a. dokumendid)</li><li>Kassa kanded</li><li>Käibedeklaratsiooni kanded</li><li>Lao kanded</li><li>Panga kanded</li><li>Pearaamatu kanded</li><li>Amordi kanded</li><li>Kirjete arv</li></ul><p></div>",
    "merit_aktiva_app_overview_text": "<p class='title'>Impordi kliendid ja tehtud töö mahud ja saad täieliku ülevaate kõikidele kliendile tehtud töödest.</p><div class='body-2'><p>Muuda oma andmete kogumine Merit Aktiva ja Uku integratsiooni abil kiireks ja täpseks. Uku impordib igale kliendile tehtud töö mahud, näiteks ostu- ja müügiarved, dokumendid, kanded jm. ning koostab ülevaatliku aruande töömahtudest ja kulunud ajast. Enam ei pea käima iga kliendi all eraldi, et saada kokku vajalikud andmed klientidele arvete koostamiseks või töömahu analüüsiks.</p><p>Erinevalt Meritist, kajastab Uku raport kõiki eelmises kuus tehtud töid, võttes arvesse muudatusi, mis sisestati eelmistesse perioodidesse. See tähendab, et enam ei pea varasemaid sissekandeid meeles pidama, eraldi välja kirjutama või võrdlema perioode - Ukul on kõik see info olemas ja Sinul samuti. Automatiseeritud andmete kogumine hoiab kokku väärtuslikku tööaega ja välistab inimlikud andmesisestusel tekkivad vead.</p><p>Uku ja Meriti integratsioon aitab Sul:</p><p><ul><li>Kiirelt ja täpselt tehtud töö andmed kokku koguda - töö mahud imporditakse automaatselt Meritist Ukusse.</li><li>Analüüsida töömahte ja selleks kulunud aega - iga kliendi kohta on täielik ülevaade.</li><li>Automatiseerida igakuisete kokkuvõtete koostamist.</li><li>Saada iga kuu ülevaade tegelikust töömahust</li></ul></p><p>Peale integratsiooni aktiveerimist saad sisse tõmmata ka varasemate perioodide töömahud.</p><p>Uku ja Meriti integratsiooniga saad importida järgmisi andmeid:</p></p><ul><li>Kannete arv</li><li>Müügi kanded</li><li>Ostu kanded</li><li>Dokumendid (ost ja müük)</li><li>Kanded (v.a. müük)</li><li>Kanded (v.a. pank)</li><li>Kanded (v.a. dokumendid)</li><li>Kassa kanded</li><li>Käibedeklaratsiooni kanded</li><li>Lao kanded</li><li>Panga kanded</li><li>Pearaamatu kanded</li><li>Amordi kanded</li><li>Kirjete arv</li></ul><p></div>",
    "Import clients": "Impordi kliente/kontakte",
    "documents_app_overview_text": "<div class='body-2'><p>Salvesta kõik failid enda ettevõtte dokumendihoidlasse. Hoia failide koopia Ukus.</p><p>Peamised võimalused:</p><ul><li><b>Kausta struktuur:</b> Defineeri peakaust, kuhu Uku failid salvestab. Soovi korral vali igale kliendile oma kaust või lase Ukul genereerida kaust klient / aasta / kuu lõikes!</li><li><b>Millised failid salvestada:</b>Uku võib salvestada kõik failid, mis ülesse laetakse või ainult failid, mis on ülesse laetud klientide poolt. Sul on täielik kontroll selle üle, mis lisatakse dokumendihoidlasse.</li><li><b>Ava failid:</b>Ülesalaetud failid avatakse otse dokumendihoidlas. Enam ei ole tarvis faili eelnevalt alla laadida.</li><li><b> Failide varundamine:</b>Soovi korral varunda failid Ukus!</li></li></ul><p></p><p>Supported file management systems:</p><div class='d-flex align-center'><img style='width: 45px;' src='/static/img/google-drive.svg'> <b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>Google Drive</b><img style='width: 55px;' src='/static/img/onedrive.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>OneDrive</b><img style='width: 50px;' src='/static/img/sharepoint.svg'><b style='padding-right: 20px; padding-left: 10px; font-size: 16px'>SharePoint</b></div><p style='padding-bottom: 30px'></p></div>",
    "Connect your existing document management system": "Ühendage oma olemasolev dokumendihaldussüsteem",
    "Main folder": "Põhikaust",
    "Under this folder, Uku automatically creates folders for each client.": "Selle kausta alla loob Uku automaatselt iga kliendi jaoks kaustad.",
    "You can customize each client folder separately under client settings.": "Iga kliendikausta saate kohandada eraldi kliendi seadete all.",
    "Automatically create Public folder for client files and Private folder for member files": "Looge automaatselt avalik kaust kliendi failide jaoks ja privaatne kaust liikmete failide jaoks",
    "Automatically create  Year / Month subfolder under each client for files sorting": "Looge automaatselt aasta/kuu alamkaust iga kliendi alla failide sorteerimiseks",
    "Automatically create  Notes and Templates subfolders under each client for files sorting": "Looge automaatselt märkmete ja mallide alamkaustad iga kliendi alla failide sorteerimiseks",
    "Add task files added by Members": "Kasutajate poolt lisatud ülesannete failide lisamine",
    "Add task files added by Clients (from emails and client portal)": "Klientide poolt lisatud ülesannete failide lisamine (e-kirjadest ja kliendiportaalist)",
    "Backup files to Uku file storage": "Failide varundamine Uku failihoidlasse",
    "Perfect example": "Täiuslik näide",
    "Setup your SharePoint connection": "SharePointi ühenduse seadistamine",
    "Site URL": "Lehe URL",
    "Client ID": "Kliendi ID",
    "Client secret": "Kliendi saladus (secret)",
    "Connection successful!": "Ühendus oli edukas!",
    "When disconnecting the service Uku will no longer be able to access the documents.": "Teenuse katkestamisel ei pääse Uku enam dokumentidele ligi.",
    "Google Drive": "Google Drive",
    "OneDrive": "OneDrive",
    "SharePoint": "SharePoint",
    "Select folder": "Valige kaust",
    "Manage": "Halda",
    "Refresh": "Uuenda",
    "Be aware of the issues before they become problems": "Ole probleemidest teadlik enne nende tekkimist.",
    "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>": "<ul><li>Kohene võrdlus kliendilepingust ning tegelikult tehtud tööst;</li><li>Ole probleemidest teadlik enne nende tekkimist;</li><li>Uku muudab tehtud töö andmed visuaalseks raportiks ja annab Sulle võimaluse jälgida kliendi kokkulepete täitmist ning reageerida õigeaegselt.</li></ul>",
    "client_portal_app_overview_text": "<div class='body-2'><p>Uku kliendiportaal tõstab sinu raamatupidamisteenuse taset tänu lihtsustatud suhtlusele raamatupidaja ja kliendi vahel. Portaaliga saad kiirelt sõnumeid vahetada, e-kirjadest vähem sõltuda ja oma kliendile turvalist dokumentide jagamise ja suhtlemise platvormi pakkuda.</p><img style='margin-bottom: 12px; width: 100%' src='/static/img/client-portal-app-description-img.png'><p>Kliendiportaali võimalused:</p><ul><li><b>Võlu-lingid:</b> Klient ei pea looma uut kasutajat ega meelde jätma parooli. Kliendiportaali saab sisse logida lingi kaudu.</li><li><b>Dokumentide digiteerimine:</b> Saada dokumendid, arved jms oma raamatupidamistarkvarasse vaid ühe klikiga.</li><li><b>Kliendisuhtlus:</b> Jaga klientidele ülesandeid ja vaheta nendega kiiresti sõnumeid.</li><li><b>Automaatsed meeldetuletused:</b> Vähenda ühekülgseid administratiivülesandeid ja jälgi kliendile määratud ülesande staatust: nähtud, tehtud.</li><li><b>Mitmekeelne portaal:</b> Uku toetab mitut keelt, et sinu klient saaks isikupärastatud kogemuse.</li><li><b>Sinu ettevõtte bränding:</b> Lisa enda ettevõtte logo, ikoonid, värvid ja tervitusvideo, et teie klient tunneks end koduselt.</li></ul><p></p><p>Näited kliendiportaali kasutamisest:</p><p><b>1. Kliendilt info hankimine:</b></p><ul><li>Lisa korduvülesanne koos dokumentide küsimisega.</li><li>Klient saab e-kirja ja meeldetuletuse koos võlu-lingiga kliendiportaali.</li><li>Kliendid laadivad üles dokumente ja vastavad päringutele kliendiportaalis.</li></ul><p></p><p><b>2. Regulaarne finantsolukorra ülevaatamine:</b></p><ul><li>Lisa korduvülesanne koos lingiga koosolekuruumi.</li><li>Klient saab e-kirja ja meeldetuletuse koos võlu-lingiga kliendiportaali.</li><li>Saada kliendile koosoleku memo koos salvestatud videoga.</li></ul><p></p><p><b>3. Kliendi liitumisprotsess:</b></p><ul><li>Lisage mallist korduvülesanne liitumisprotsessiga.</li><li>Klient saab e-kirja ja meeldetuletuse koos võlu-lingiga kliendiportaali.</li><li>Klient täidab talle antud ülesanded (juurdepääsud, aruanded).</li></ul><p></p><p>Need kasutusviisid näitavad, kuidas Uku kliendiportaal enda kasuks tööle panna.</p><p><a href='https://getuku.com/client-portal' target='_blank'>Loe rohkem &rsaquo;</a></p></div>",
    "Branding": "Bränding",
    "Subdomain": "Alamdomeen",
    "Default language": "Vaikimisi keel",
    "Client portal URL in other languages": "Kliendiportaal teistes keeltes",
    "Copy URL": "Kopeeri URL",
    "Trademark": "Kaubamärk",
    "Default signature": "Vaikimisi allkiri",
    "Trademark text color": "Kaubamärgi teksti värv",
    "Choose color": "Vali värv",
    "Brand background color": "Tausta värv",
    "Logo": "Logo",
    "Max. dimensions 180 x 60 px": "Maksimaalne suurus 180 x 60 px",
    "Favicon": "Favicon",
    "Delete icon": "Kustuta ikoon",
    "Upload icon file": "Lae üles ikoon",
    "Recommended size 260 x 260 px": "Soovituslik suurus 260 x 260 px",
    "Company description": "Ettevõtte kirjeldus",
    "Displayed on the login page.": "Kuvatakse sisselogimislehel",
    "Describe here what services you offer and how you help your clients.": "Kirjelda siin, milliseid teenuseid ettevõtte pakub ja kuidas aitad enda kliente",
    "Welcome video": "Tutvustav video",
    "Displayed on the login page when your client contact enters for the first time": "Kuvatakse sisselogimislehel kui kliendi kontakt siseneb kliendiportaali esimest korda",
    "Use Uku video": "Kasuta Uku videot",
    "View": "Vaata",
    "Use other video": "Vali muu video",
    "Youtube or Vimeo video URL": "YouTube'i või Vimeo video URL",
    "Show file upload box for client tasks": "Kuva dokumentide üleslaadimise kasti kliendi ülesannetel",
    "Invalid data": "Vigased andmed",
    "Client portal preview": "Kliendiportaali eelvaade",
    "Client portal URL for {0} copied to clipboard": "Kliendiportaali URL {0} keelele kopeeritud clipboardi",
    "Personalize your client portal's menu": "Isikupärastage oma kliendiportaali menüü",
    "Menu links saved": "Salvestatud menüü lingid",
    "Add custom links to essential items such as: Documents, Financial reports, Onboarding forms, Feedback surveys, Service agreements, Pricing, Instructions, Invoices. This section allows you to build the menu structure, set the order of items, and define default links. You can also customize names and links for each client individually. Only menus with defined links are displayed in client portal. <a href='/api/help_link/cp_menu_links' target='_blank'>Read more ›</a>": "Lisage kohandatud lingid olulistele elementidele, nagu: Teenuslepingud, hinnakujundus, juhised, arved. Selles jaotises saate luua menüü struktuuri, määrata elementide järjekorra ja määratleda vaikimisi lingid. Samuti saate kohandada nimesid ja linke iga kliendi jaoks eraldi. Kliendiportaalis kuvatakse ainult määratletud linkidega menüüd. <a href='/api/help_link/cp_menu_links' target='_blank'>Loe edasi '</a>",
    "Menu links": "Menüü lingid",
    "Uku will import all clients from FreeAgent. In the final step you can select which clients you want to add or update.": "Uku impordib kõik kliendid FreeAgentist. Viimases etapis saate valida, milliseid kliente soovite lisada või uuendada.",
    "Before importing clients, you need to connect with FreeAgent.": "Enne klientide importimist tuleb luua ühendus FreeAgentiga.",
    "Connect to FreeAgent": "Ühendage FreeAgentiga",
    "Connected to FreeAgent": "Ühendatud FreeAgentiga",
    "freeagent_app_overview_text": "<p class=‘title’>Automatiseeri ettevõtte seadistamine importides kliendid tarkvarast Freeagent!</p><div class=‘body-2’><p>Impordi kõik kliendid tarkvarast Freeagent ainult paari vajutusega.</p></div>",
    "Add recurring task": "Lisa korduvülesanne",
    "Reminder tasks updated": "Klientide korduvülesanded uuendatud",
    "Create recurring tasks for Companies House clients.": "Loo korduvülesanded Companies House klientidele.",
    "companies_house_app_overview_text": "<p class='title'>Never forget to file your clients' annual statements with Companies House.</p> <div class='body-2'><p>Activating Companies House in Uku will:</p><p><ul><li>Set up Companies House client fields for your clients based in the United Kingdom.</li><li>Automatically keep Companies House data up-to-date for these clients.</li></ul></p><p>Set up reminders to file your clients' statements and tax returns:</p><p><ul><li>Set up yearly recurring tasks for different annual statements.</li><li>Reminder tasks will be created separately for every client based on that client's due dates.</li><li>Customise when these tasks should appear and what should be done.</li></ul></p></div>",
    "buttons": "kiirvalikut",
    "Show to me": "Näita mulle",
    "magic_button_app_overview_text": "<p class='title'>Sisesta kõik tööd kohe Ukusse.</p><div class='body-2'><p>Ühe klikiga loo uus ülesanne ja alusta ajamõõtmist. Nii saad mugavalt vahele tulevad ülesanded (nt telefonikõne ja e-post) Ukusse sisestada.</p><p>Ülesande kiirvalikud võimaldavad vahele tulevad ülesandeid (nt telefonikõne, e-post) mugavalt Ukusse sisestada. Nii oled kindel, et kõik tööd saavad Ukusse sisestatud.</p><p>Kiirvalikud ülesande loomiseks</p><p><ul><li>Ühe klikiga sisesta uus ülesanne ja alusta ajamõõtmist (liigu päises + nupule).</li><li>Seadista kiirvalikud lähtuvalt enda vajadustest.</li><li>Ülesande lõppedes täpsusta klienti ja muid andmeid.</li><li>Kiirvalikutesse tekib sinu eelmine pooleliolev ülesanne, millega saad mugavalt jätkata.</li></ul><p></div>",
    "Buttons": "Kiirvalikud",
    "Member rights": "Kasutajate õigused",
    "Allow managers to view and create their client contracts and invoices": "Luba kliendi peakasutajatel näha ja luua oma klientide lepinguid ja arveid",
    "Allow members to view and create their client invoices": "Luba liikmetel näha ja luua oma klientide arveid",
    "Allow members to view their client invoices": "Luba liikmetel näha oma klientide arveid ",
    "Allow only owners to add and update products": "Luba ainult omanikel tooteid lisada ja uuendada",
    "Allow members to send invoices to clients": "Luba liikmetel saata arveid oma klientidele",
    "Allow members to confirm their client invoice rows": "Luba liikmetel kinnitada kliendi arveridu",
    "Send PDF invoice": "Saada PDF arve",
    "Send invoice copy": "Saada arve koopia",
    "Default rounding": "Vaikimisi ümardamine",
    "Round all times up to x": "Ümardage kõik ajad ülespoole",
    "Time rounding increment": "Aja ümardamisjärk",
    "Apply time rounding to": "Ümarda ajakirjed",
    "Default configuration": "Vaikimisi seadistused",
    "Invoice date": "Arve kuupäev",
    "Invoice entry date": "Arve sisestamise kuupäev",
    "Bill tracked time by": "Aja arveldamise alus",
    "Bill task field by": "Lisavälja arveldamise alus",
    "Create one invoice merging invoices from the same period": "Liida sama perioodi arved ning koosta üks arve",
    "Invoices from the same period": "Sama perioodi arved",
    "Hide zero sum lines": "Peida nullsumma read",
    "By default, time entry is billable": "Vaikimisi on ajakirje arveldatav",
    "Invoice number": "Arve nr",
    "Prefix": "Prefiks",
    "Suffix": "Sufiks",
    "Google Gmail": "Google Gmail",
    "Microsoft Outlook": "Microsoft Outlook",
    "Billing settings saved": "Arveldamise seaded salvestatud",
    "billing_app_overview_text": "<p class='title'>Kiirenda oma kliendi arveldusprotsessi paindlike hinnakirjade ja nutikate arvetega.</p><div class='body-2'><p>Automatiseeri arveldusprotsess ja säästa arvete manuaalse koostamise pealt väärtuslikku aega. Uku koostab dünaamiliselt tehtud töö põhjal kõik arved ise, aidates Sul teenida klientidelt õiglast tulu. Enam pole vaja koguda andmeid erinevatest tarkvaradest ega exceli tabelitest – Ukul on kõik vajaminev info olemas, mille alusel koostab arved. Sinu ülesandeks jääb need vaid üle vaadata ja välja saata.</p><p>Uku arveldamine:</p><p><ul><li><b>Säästab aega,</b> vähendades administratiivset tööd</li><li><b>Suurendab tulu,</b> koostades kogu tehtud töö eest arveid</li><li><b>Vähendab vigade hulka,</b> eemaldades tähelepanematusest tulenevad eksimused</li><li><b>Tagab stabiilse tuluvoo</b> õigeaegse arveldamisega</li><li><b>Suurendab läbipaistvust</b> tänu üksikasjalikele ja hõlpsasti juurdepääsetavatele kliendiandmetele</li><li><b>Suurendab täpsust,</b> jättes meelde kõik lepingumuudatused alates 1. päevast</li><li><b>Võimaldab paindlikkust</b> ja pakub Sinu kliendile paremat kliendikogemust</li></ul></p><p>Uku toetab kõikvõimalikke hinnakujundusmudeleid, sealhulgas:</p><p><ul><li>Tunnihinnad (nt raamatupidaja hind, assistendi hind)</li><li>Fikseeritud paketid (nt igakuine või -aastane hind)</li><li>Väärtuspõhine hinnakujundus (nt teenuse(te) tajutav väärtus)</li><li>Töömahupõhine arveldamine (nt sisestatud dokumentide, kirjete või kannete hulk)</li><li>Lisateenused (nt raamatupidamise aastaaruanne, konsultatsioon)</li><li>Mitme mudeli kombinatsioon (nt fikseeritud pakett + lisatöötunnid; töömaht + konsultatsioonitunnid jne)</li></ul></p><p>Automaatselt koostatud arved saad üle vaadata, (vajadusel) muuta ja kõik korraga välja saata.</p><p><a href='https://help.getuku.com/en/articles/5230791-kuidas-tootab-arveldamise-lahendus' taget='_blank'>Lisateavet Uku arveldamise kohta leiad siit.</a> </p><p>Kui mõtled võtta kasutusele Uku arvelduse ja soovid meie eksperdiga konsultatsiooni, siis <a href='https://calendly.com/getuku/uku-arveldamine' target='_blank'>broneeri aeg siin</a> (tasuta).</p></div>",
    "Products": "Tooted",
    "Contract templates": "Lepingu mall",
    "Invoice templates": "Arvete mallid",
    "Tools": "Tööriistad",
    "Replace tax": "Asenda maksumäär",
    "Old tax": "Vana maksumäär",
    "New tax": "Uus maksumäär",
    "Find tax": "Leia maksumäär",
    "Replace VAT in products": "Muuda KM toodetel",
    "Replace VAT in master contracts": "Muuda KM lepingu mallides",
    "Replace VAT in client contracts & draft invoices": "Muuda KM kliendi lepingutes ja avatud arvetes",
    "Replace VAT values": "Käibemaksu muutmine",
    "This action cannot be undone": "Seda tegevust ei saa tagasi pöörata",
    "Replace": "Asenda",
    "Result": "Tulemus",
    "PDF templates": "PDF mallid",
    "E-mail templates": "E-kirja mall",
    "Edit PDF template": "Muuda pdf malli",
    "Import classificators": "Impordi klassifikaatorid",
    "products": "toodet",
    "product": "toode",
    "Product / service": "Toode / teenus",
    "Calculate": "Kalkuleeri",
    "Article": "Artikkel",
    "Resource": "Ressurss",
    "Cost center": "Kulukeskus",
    "Taxes": "Maksud",
    "Code": "Kood",
    "Source": "Allikas",
    "Articles": "Artiklid",
    "Resources": "Ressurssi",
    "Cost centers": "Kulukeskused",
    "Units": "Ühikud",
    "Unit": "Ühik",
    "Bank accounts": "Pangakontod",
    "Bank account": "Pangakonto",
    "Bank name": "Panga nimi",
    "SWIFT code": "SWIFT-kood",
    "VAT number": "KMKR",
    "Do you wish to import only new data or also overwrite existing?": "Kas soovid importida ainult uued väärtused või uuendada ka olemasolevaid?",
    "Only new": "Ainult uued",
    "New items will be added. Existing ones will remain unchanged by import.": "Imporditakse ainult uued väärtused. Olemasolevaid andmeid ei muudeta.",
    "Import everything": "Impordi kõik",
    "Connect accounting service": "Ühenda raamatupidamisprogrammiga",
    "Service": "Teenus",
    "API ID": "API ID",
    "API key": "API võti",
    "Company Account Id": "Ettevõtte konto ID",
    "Api secret": "Salajane võti",
    "E-conomic": "e-conomic",
    "SmartAccounts": "Smart Accounts",
    "Test": "Testi",
    "Lock time entries": "Lukusta ajakirjed",
    "Owner rights": "Omaniku seaded",
    "Disable company settings edit for all members": "Keela kasutajatel ettevõtte seadete muutmine",
    "Disable personal clients for members": "Keela kasutajatel isiklike klientide lisamine",
    "Show member birthdays": "Kuva kalendris kasutajate sünnipäevi",
    "Show contact birthdays": "Kuva kalendris kliendikontaktide sünnipäevi",
    "Weekly @ Sun {0}": "Igal pühapäeval {0}",
    "Monthly @ last day of month": "Iga kuu viimasel päeval 23:59",
    "Company event list": "Ettevõtte sündmused",
    "How long?": "Kestus",
    "Invoice no.": "Arve nr",
    "Login options": "Sisselogimise viisid",
    "Tenant ID (optional)": "Tenant ID (pole kohustuslik)",
    "Add Active Directory tenant ID, if only users belonging to this tenant are allowed to connect": "Lisa Active Directory tenant ID, kui lubad ühendada ainult selle tenanti kontosid",
    "How to find ID’s?": "Kuidas leida tenant ID-d?",
    "Microsoft connected": "Microsoft ühendatud",
    "Google connected": "Google ühendatud",
    "Edit company": "Muuda ettevõtte seadeid",
    "Timezone": "Ajatsoon",
    "Invoice email": "Saada arve koopia",
    "Subscription plan": "Pakett",
    "Payment failed": "Makse ebaõnnestus",
    "Retry payment": "Proovi uuesti",
    "Next payment": "Järgmine makse",
    "Update payment method": "Uuenda makseviisi",
    "Plan": "Plaan",
    "Choose a plan": "Vali plaan",
    "Change plan": "Muuda paketti",
    "{0}-day free trial until {1}": "{0} päeva tasuta prooviperiood kuni {1}",
    "monthly": "kuumakse",
    "yearly": "aastamakse",
    "{0} member": "{0} kasutaja",
    "{0} members": "{0} kasutajat",
    "{0} plan": "{0} plaan",
    "Cancelled (valid until {0})": "Tühistatud (kehtiv kuni {0})",
    "Your trial expired on {0}": "Sinu prooviperiood lõppes {0}",
    "Your subscription expired on {0}": "Sinu pakett aegus {0}",
    "It’s nice to see you! If you'd like to get up and running with a Uku subscription, click Choose a plan": "Tore sind näha! Vali endale sobiv pakett ja jätka Uku kasutamist",
    "Save {0} by paying for a year!": "Vali aastamakse ja säästa {0} !",
    "Choose plan": "Vali pakett",
    "Pay annually": "Tee aastamakse",
    "Instructions sent!": "Juhend on saadetud!",
    "Instructions for resetting your password have been sent to": "Juhend salasõna uuendamiseks on välja saadetud",
    "You’ll receive this email within 5 minutes. Be sure to check your spam folder, too.": "Saad kirja 5 minuti jooksul (kontrolli ka rämpskirja kausta).",
    "Back to login page": "Tagasi sisselogimise lehele",
    "Get new password": "Salasõna uuendamine",
    "Pick a password": "Salasõna",
    "Use minimum 8 characters with letters & numbers": "Kasuta minimaalselt 8 tähemärki",
    "Create your Uku Account": "Loo enda Uku konto",
    "Connect your Xero Account": "Seo enda Xero kontoga",
    "Phone": "Telefon",
    "I agree to the": "Nõustun",
    "Terms of Service": "Kasutustingimustega",
    "Next": "Edasi",
    "Having trouble?": "Vajad abi?",
    "We can help": "Vaata abikeskust või kirjuta",
    "Log in instead": "Logi sisse",
    "You are invited to join": "Sind on kutsutud ühinema ettevõttega",
    "Accept invitation": "Võta kutse vastu",
    "Check your email": "Vaata oma e-posti",
    "I sent you an email with a link to activate your account. This is important to ensure the security of your account.": "Saatsin sulle e-kirja, kus on link, millega saad oma konto aktiveerida. See on oluline, et tagada konto turvalisus.",
    "Go to": "Mine",
    "Need a new password?": "Vajad uut salasõna?",
    "Enter your e-mail address and we will send you directions for changing your password": "Sisesta oma e-posti aadress ja saadame sulle juhendi salasõna vahetamiseks",
    "Send me instructions": "Saada mulle juhend",
    "Never mind, go back": "Ei midagi, mine tagasi",
    "No login options enabled. Please contact the company owner": "Sisselogimismoodused pole määratud. Palun suhtle ettevõte administraatoriga.",
    "Log in to Uku": "Logi Ukusse sisse",
    "Forgot password?": "Unustasid salasõna?",
    "Don't have account?": "Sul ei ole veel kontot?",
    "Create account": "Loo konto",
    "No. 1 tool for accounting practices. Automated workflows, time tracking, reports, monitoring, CRM. Get work done on time & profitably. Try for free!": "Parim töövahend raamatupidamisbüroodele. Automatiseeritud tööülesanded, aja jälgimine, raportid, monitooring, CRM. Tööd tehtud õigel ajal ja kasumlikult. Proovi tasuta!",
    "Total items:": "Kokku: ",
    "Add new": "Lisa uus",
    "Amount": "Summa",
    "Account created range": "Konto loomise vahemik",
    "Usage limit": "Kasutuslimiit",
    "Valid until": "Kehtiv kuni",
    "Edit help link": "Muuda abiartikli linki",
    "New help link": "Uus abiartikli link",
    "Name key": "Nime otsing",
    "Country code": "Riigi kood",
    "Period (months)": "Periood (kuud)",
    "Account created from": "Konto loodud alates kp",
    "Account created until": "Konto loodud kuni kp",
    "Used count": "Kasutatud arv",
    "Free days": "Vabad päevad",
    "Sum": "Summa",
    "Create voucher": "Loo kinkekood",
    "Edit voucher": "Muuda kinkekoodi",
    "Are you sure to delete this voucher?": "Kas oled kindel, et soovid kinkekoodi kustutada?",
    "row | rows": "rida | read",
    "Add event": "Lisa event",
    "Are you sure you wish to delete this event?": "Kas oled kindel, et soovid sündmuse kustutada?",
    "event | events": "üritus | üritust",
    "Security object id": "Kontroll olem",
    "Direct rights": "Otsesed õigused",
    "Computed rights": "Arvutatud õigused",
    "Add link": "Lisa viide",
    "Are you sure you wish to delete this entry?": "Kas oled kindel, et soovid ajakirje kustutada?",
    "link | links": "viide | viidet",
    "Event type": "Ürituse tüüp",
    "Date from": "Alates kp",
    "Date until": "Kuni kp",
    "Shortened by h": "Lühendatud tundide võrra",
    "Category": "Kategooria",
    "demo | demos": "demo | demod",
    "Created at": "Loodud",
    "Invited by": "Kutsutud",
    "referral | referrals": "Soovita sõpra | Soovita sõpru",
    "Companies": "Ettevõtted",
    "Leads": "Liidid",
    "Demos": "Demod",
    "Vouchers": "Kinkekoodid",
    "KPI": "KPI",
    "Referrals": "Soovituskirjad",
    "Activity log": "Tegevuste logi",
    "Notifications": "Teavitused",
    "Me": "Mina",
    "Important notifications will appear here.": "Siia ilmuvad Sinule olulised teavitused.",
    "Back": "Tagasi",
    "Return to UKU": "Tagasi seadetesse",
    "Choose plan for {0}": "Vali {0} pakett",
    "First payment will be made after the end of the trial period.": "Esimene makse toimub pärast prooviaja lõppu.",
    "Members and subscription can always be changed.": "Kasutajate arvu ja paketti saad alati muuta.",
    "Your subscription is externally managed by Xero": "Teie tellimus on Xero poolt väliselt hallatav",
    "Select plan": "Valige plaan",
    "Billing period": "Arveldamise periood",
    "Compare features": "Võrdle võimalusi",
    "Cancel uku subscription": "Tühista Uku tellimus",
    "{0} discount": "{0} allahindlus",
    "You have currently<br />{0} active member": "Sul on hetkel<br />{0} aktiivne kasutaja",
    "You have currently<br />{0} active members": "Sul on hetkel<br />{0} aktiivset kasutajat",
    "Select yearly plan": "Vali aastane pakett",
    "Select monthly plan": "Vali kuine pakett",
    "Attention!": "Tähelepanu!",
    "Plan change request": "Plaani muutmise taotlus",
    "If you want to use Uku for free then deactivate your account and continue with {0} plan": "Kui soovid jätkata Uku kasutamist tasuta, siis deaktiveeri oma konto ja jätka {0} paketiga",
    "per member/month (billed yearly)": "kasutaja kohta/kuu (aastamakse)",
    "or {0} per member/month (monthly)": "või {0} kasutaja kohta/kuu (kuumakse)",
    "Everything in {0}, plus:": "Kõik plaanis {0}, lisaks:",
    "Compare plans, feature-by-feature": "Võrdle pakettide võimalusi",
    "Deactivate account": "Deaktiveeri ettevõte",
    "Are you sure to deactivate {0} account?": "Kas oled kindel, et soovid ettevõtte {0} deaktiveerida?",
    "If you choose to continue with freelancer plan your company account will be deactivated. Data that is related to this company will be removed.": "Kui otsustad jätkata Üksiku kasutajana, siis Sinu ettevõte konto deaktiveeritakse. Kontoga seotud andmed eemaldatakse.",
    "Deactivate": "Deaktiveeri",
    "Teamwork": "Meeskonnatöö",
    "Unlimited clients + import": "Piiramatult kliente + import",
    "Access management": "Kasutajarollid ja õigused",
    "Custom fields": "Lisaväljad",
    "Live chat support": "Reaalajas kasutajatugi",
    "AML": "Rahapesu tõkestamine",
    "API": "API",
    "Client Portal": "Kliendiportaal",
    "New!": "Uus!",
    "Custom integrations": "Eri integratsioonid",
    "Assisted clients import": "Abi klientide impordil",
    "Tailor-made team workshop": "Põhjalik tiimi treening",
    "Early access to features": "Ligipääs piloot lahendustele",
    "Pay by invoice": "Arvega tasumine",
    "Dedicated account manager": "Personaalne kliendihaldur",
    "Hi! Your trial is over. Please choose {0} subscription plan to continue work": "Tere! Teie prooviaeg ettevõttega {0} on läbi. Töö jätkamiseks vali sobiv pakett",
    "Hi! You need to upgrade {0} subscription plan to use that feature": "Tere! Selle tööriista kasutamiseks pead uuendama {0} paketti",
    "Waiting for the subscription to complete": "Ootab tellimuse lõpuleviimist",
    "VAT": "KM",
    "This is subscription period amount.": "Selle summa pead tasuma igas järgnevas arveldusperioodis.",
    "You save yearly {0}": "Hoiad aastas kokku {0}",
    "Add voucher": "Lisa kinkekood",
    "Existing credit": "Olemasolev krediit",
    "Current payment": "Praegune makse",
    "This is the current payment amount. Your bank also requires confirmation for the subscription period amount.": "Selle summa pead tasuma praegu, et aktiveerida soovitud muudatused jooksvaks arveldusperioodiks. Sinu pank küsib Sult kinnitust ka perioodiliste maksete summale.",
    "Confirm subscription {0}": "Kinnita plaan {0}",
    "Your subscription will renew on": "Sinu paketi järgmine makse tehakse",
    "Thank you for believing in us!": "Aitäh, et usud meisse!",
    "Uku team": "Uku meeskond",
    "Voucher {1} (-{0}%)": "Kinkekood {1} (-{0}%)",
    "Voucher {0}": "Kinkekood {0}",
    "New plan": "Uus plaan",
    "Changed plan": "Muuda paketti",
    "Add {0} member": "Lisa {0} kasutaja",
    "Add {0} members": "Lisa {0} kasutajat",
    "Remove {0} member": "Eemalda {0} kasutaja",
    "Remove {0} members": "Eemalda {0} kasutajat",
    "No changes to plan": "Jätka sama paketiga",
    "Discount -{0}% with Yearly subscription": "Allahindlus -{0}% aastase plaaniga",
    "Yearly discounted price (-{0}%)": "Igaastane makse soodustusega (-{0}%)",
    "Subscription updated": "Plaan uuendatud",
    "Please wait": "Palun oota",
    "Your payment failed": "Sinu makse ebaõnnestus",
    "Please check that you entered the data correctly or use another card": "Palun kontrolli, kas sisestasid andmed õigesti, või kasuta teist kaarti",
    "Try again": "Proovi uuesti",
    "Pay": "Maksa",
    "Payment": "Makse teostamine",
    "Payment method updated": "Makseviis uuendatud",
    "Edit member": "Muuda kasutajat",
    "First name": "Eesnimi",
    "Last name": "Perenimi",
    "External ID": "Väline ID",
    "Select groups": "Vali grupid",
    "Administrator": "Administraator",
    "Activate member": "Aktiveeri kasutaja",
    "Deactivate member": "Deaktiveeri kasutaja",
    "Paid member": "Tasuline kasutaja",
    "Send an invitation": "Saada kutse",
    "Limited": "Seadistamisel",
    "No invite, no access": "Kutset pole saadetud, ligipääs puudub",
    "Free until activated": "Aktiveerimiseni tasuta",
    "No access, no charge": "Ligipääs puudub, Ukus tasuta",
    "Hidden member": "Peidetud kasutaja",
    "Edit members": "Muuda kasutajaid",
    "Select user": "Vali kasutaja",
    "Member will be assigned to every selected client": "Kasutaja lisatakse kõikide valitud klientide juurde",
    "Member will be removed from all selected clients": "Kasutaja eemaldatakse kõikide valitud klientide küljest",
    "Assign user": "Määra kasutaja",
    "Set as primary user": "Määra vaikimisi kasutajaks",
    "Added as a default user when adding a task plan": "Lisatakse vaikimisi kasutajaks tööülesannete plaani kinnitamisel",
    "Remove from new tasks": "Eemalda tuleviku ülesannete küljest",
    "Remove from plan tasks": "Eemalda plaaniliste ülesannete küljest",
    "Remove": "Eemalda",
    "Admin": "Peakasutaja",
    "Remove user": "Eemalda kasutaja",
    "Assign to incomplete tasks": "Lisa lõpetamata ülesannetele",
    "Reassign incomplete tasks": "Suuna ümber lõpetamata ülesanded",
    "Assign to plan tasks": "Määra plaaniliste ülesannete tegijaks",
    "Reassign plan tasks": "Suuna ümber plaanilised ülesanded",
    "Owner will be assigned to tasks if the removed user was the last assigned user.": "Kui eemaldatav kasutaja on ülesande ainsaks kasutajaks, suunatakse ülesanne ettevõtte konto omanikule.",
    "Run integration": "Impordi andmed",
    "Run": "Impordi",
    "Integration configuration": "Integratsiooni seadistamine",
    "Read the manual": "Loe juhendit",
    "Api key": "API võti",
    "Are you sure to delete this integration info?": "Kas oled kindel, et soovid integratsiooni info kustutada?",
    "Edit Contracts": "Muuda lepinguid",
    "Replace following contracts": "Asenda järgnevad lepingud",
    "Append services to following contracts": "Lisa teenused järgnevatele lepingutele",
    "Choose template": "Vali mall",
    "Append only": "Täienda",
    "with template": "malliga",
    "All existing contracts": "Kõik lepingud",
    "All quarterly contracts": "Kõik kvartaalsed lepingud",
    "All monthly contracts": "Kõik kuised lepingud",
    "All yearly contracts": "Kõik aastased lepingud",
    "Next invoice number": "Järgmine arve number",
    "Number is too big, it cannot exceed 15 digits": "Number on liiga pikk, max pikkus 15 ühikut.",
    "Replace topic": "Asenda teema",
    "All tasks and plans with current topic will be replaced with the new selected topic.": "See teema asendatakse kõigis ülesannetes ja tööplaanides valitud uue teemaga.",
    "Topics replaced": "Teemad asendatud",
    "All tasks with the topic `{0}` will be replaced with `{1}`. This is not reversible. Are you sure?": "Kõigi teemaga `{0}` ülesannete uueks teemaks saab `{1}`. Seda ei saa tagasi muuta. Kas oled kindel, et soovid teema asendada?",
    "Name of topic": "Teema nimetus",
    "New time entries will be marked as non-billable": "Uued ajakanded märgistatakse kui mittearvutatavad",
    "Change topic": "Muuda teemat",
    "Add new topic": "Lisa uus teema",
    "This topic is in use. Do you wish to archive it?": "Teema on kasutusel. Kas soovite arhiveerida?",
    "Are you sure that you want to delete this topic?": "Kas oled kindel, et soovid teema kustutada?",
    "These items will be deleted permanently": "Valitud kustutatakse jäädavalt",
    "Are you sure that you want to delete this client group?": "Kas oled kindel, et soovid kliendigrupi kustutada?",
    "This client group is in use. Do you wish to archive it?": "See kliendigrupp on kasutuses. Kas soovid selle arhiveerida?",
    "Edit client group": "Muuda kliendi gruppi",
    "New client group": "Lisa kliendigrupp",
    "Price": "Hind",
    "Quantity": "Kogus",
    "Unit will be translated to client language": "Ühik tõlgitakse arvel kliendi keelde",
    "Pick date & time": "Vali kuupäev ja kellaaeg",
    "Share equally": "Jaga võrdselt",
    "Change existing": "Muuda olemasolevat",
    "Choose bookmark": "Vali, millist soovid muuta",
    "New title": "Uus pealkiri",
    "Set as my default view": "Tee see minu vaikimisi vaateks",
    "Signature name": "Allkirja nimi",
    "Layout": "Paigutus",
    "Top": "Üleval",
    "Middle": "Keskel",
    "Bottom": "All",
    "Logo left": "Logo vasakule",
    "Logo top": "Logo üleval",
    "No logo": "Logo puudub",
    "Linkedin": "Linkedin",
    "Facebook": "Facebook",
    "Email signature": "E-posti signatuur",
    "Edit email signature": "E-posti allkirja muutmine",
    "Add email signature": "Lisa e-posti allkiri",
    "Font color": "Fondi värvus",
    "Actions": "Tegevused",
    "Delete signature": "Kustuta allkiri",
    "Do you wish to update related contracts and invoices?": "Kas soovite uuendada seotud lepingud ja arved?",
    "Update contract templates, active contracts and open invoices.": "Uuenda lepingu malle, aktiivseid kliendilepinguid ja avatud arveid",
    "The following fields will be updated": "Uuendatakse need väljad",
    "Custom Value": "Eriväärtus",
    "This product is in use. Do you wish to archive it?": "Toode on kasutusel. Kas soovite selle arhiveerida?",
    "Are you sure that you want to delete this product?": "Kas oled kindel, et soovid toote kustutada?",
    "Customize for client": "Kohanda kliendi jaoks",
    "Customize for template": "Kohanda malli jaoks",
    "Open product template": "Ava toote mall",
    "Create product template": "Loo toote mall",
    "Master template": "Üldmall",
    "Client product": "Kliendi toode",
    "Client product / service": "Kliendi toode / teenus",
    "New client product": "Uus kliendi toode",
    "Template product": "Malli toode",
    "Template product / service": "Malli toode / teenus",
    "New template product": "Uus malli toode",
    "Edit translations": "Muuda tõlkeid",
    "Billable topics": "Arveldatavad teemad",
    "Billable time": "Arveldatav aeg",
    "Minimum quantity": "Minimaalne kogus",
    "Minimum time": "Miinimum aeg",
    "Integration parameters": "Integratsiooni parameetrid",
    "Empty values will use product default": "Jäta need tühjaks kui soovid kasutada lepingumalli toote väärtusi",
    "Pricing": "Hinnastamine",
    "DC %": "AH %",
    "Sum all matching rows": "Summeeri kõik kohalduvad read",
    "When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.": "Lülita sisse, et summeerida arvel kokku kõigi kohalduvate vahemike hinnad. Vaikimisi rakendatakse ainult kõrgeima kohalduva vahemiku hinda.",
    "Prices since": "Alates kuupäevast",
    "Add price": "Lisa hind",
    "Add pricing period": "Lisa hinnastamisperiood",
    "Update contracts": "Uuenda lepingud",
    "(Without topic)": "(Ilma teemata)",
    "Fixed price": "Püsihind",
    "Product": "Toode",
    "Event created": "Sündmus lisatud",
    "Project created": "Projekt loodud",
    "Event deleted": "Sündmus kustutatud",
    "Project deleted": "Projekt kustutatud",
    "Workflow added": "Tööplaan lisatud",
    "Workflow removed": "Tööplaan eemaldatud",
    "Workflow updated": "Tööplaan uuendatud",
    "Event cancelled": "Sündmus tühistatud",
    "Project cancelled": "Projekt tühistatud",
    "Event reactivated": "Sündmus taastatud",
    "Project reactivated": "Projekt aktiveeritud",
    "Event archived": "Sündmus arhiveeritud",
    "Project archived": "Projekt arhiveeritud",
    "Event unarchived": "Arhiveeritud sündmus taastatud",
    "Project unarchived": "Projekt taastatud",
    "Event changed": "Sündmus muudetud",
    "Project changed": "Projekt muudetud",
    "Event status changed: {0}": "Sündmuse staatus muudetud: {0}",
    "Project status changed: {0}": "Projekti staatus muutus: {0}",
    "Event status changed": "Sündmuse staatus muudetud",
    "Project status changed": "Projekti staatus muutus",
    "Task created": "Ülesanne loodi",
    "Task changed": "Ülesannet muudeti",
    "Task finished": "Ülesanne lõpetati",
    "Task not finished": "Ülesanne lõpetamata",
    "Task deleted": "Ülesanne kustutati",
    "Add project": "Lisa projekt",
    "Hide filters": "Peida filtrid",
    "Show filters": "Näita filtreid",
    "Cancel event": "Tühista sündmus",
    "Cancel project": "Tühista projekt",
    "Manage event fields": "Seadista sündmuse väljasid",
    "Manage project fields": "Seadista projekti väljad",
    "New event": "Uus sündmus",
    "New project": "Uus projekt",
    "{0} (Copy)": "{0} (Koopia)",
    "Are you sure you wish to delete this project?": "Kas oled kindel, et soovid projekti kustutada?",
    "Are you sure to archive this event?": "Kas oled kindel, et soovid sündmuse arhiveerida?",
    "Are you sure to archive this project?": "Kas oled kindel, et soovid projekti arhiveerida?",
    "Are you sure to cancel this event?": "Kas oled kindel, et soovid sündmuse tühistada?",
    "Are you sure to cancel this project?": "Kas oled kindel, et soovid projekti tühistada?",
    "Communication": "Suhtlus",
    "Log": "Logi",
    "Create event workflow": "Loo sündmuse tööplaan",
    "Create project workflow": "Lisa projekti tööplaan",
    "Use workflow templates to set up tasks effectively or": "Kasuta tööplaani malli, et seadistada projekti ülesanded või",
    "Add tasks manually": "Lisa ülesanded ükshaaval",
    "Save bookmark": "Salvesta vaade",
    "Remove filters": "Eemalda filtrid",
    "Filter": "Filtreeri",
    "Show multiselect": "Kuva valimine",
    "To do today": "Täna",
    "This and next month": "See ja järgmine kuu",
    "Last 3 months": "Viimased 3 kuud",
    "Next 3 months": "Järgmised 3 kuud",
    "Starts": "Algab",
    "To do": "Teha",
    "today": "täna",
    "tomorrow": "homme",
    "yesterday": "eile",
    "Previous week": "Eelmine nädal",
    "Group similar tasks": "Grupeeri sarnased",
    "Group by client": "Grupeeri kliendi järgi",
    "Group by date": "Grupeeri kuupäeva järgi",
    "Group by topic": "Grupeeri teema järgi",
    "Are you sure to remove google?": "Kas oled kindel, et soovid Google'i ühenduse eemaldada?",
    "Google log in": "Google'i sisselogimine",
    "Microsoft log in": "Sisselogimine Microsoftiga",
    "Are you sure to remove microsoft?": "Kas oled kindel, et soovid Microsofti ühenduse eemaldada?",
    "Are you want to disconnect Xero?": "Kas oled kindel, et soovid Xero lahti ühendada?",
    "Reset password": "Lähtesta salasõna",
    "Your details": "Sinu andmed",
    "City": "Linn",
    "Regional format": "Piirkondlik vorming",
    "Default company": "Vaikimisi ettevõte",
    "Lock time entries notification": "Ajakirjed lukustuvad peatselt",
    "Notify by": "Teavitusviis",
    "Delete my account": "Kustuta minu konto",
    "Attention": "Tähelepanu",
    "Are you sure that you want to delete your account?": "Kas oled kindel, et soovid oma konto kustutada?",
    "Notification": "Süsteemiteavitusega",
    "Notification & email": "Süsteemiteavitusega ja e-postile",
    "Vacations / absence": "Puhkused ja eemalolekud",
    "Edit balance": "Muuda jääki",
    "View history": "Tegevuste ajalugu",
    "Request": "Avaldus",
    "How long": "Kestus",
    "Requested": "Esitatud",
    "Approved": "Kinnitatud",
    "Rejected": "Tagasi lükatud",
    "In review": "Ootab kinnitamist",
    "Change": "Muuda",
    "Agreements": "Kokkulepped",
    "New agreement": "Uus kokkulepe",
    "Change agreement": "Muuda kokkuleppeid",
    "Stop demo": "Lõpeta demo",
    "Show": "Kuva",
    "Don't show": "Ei kuvata",
    "Don't send": "Ei saadeta",
    "Email workdays at 7 AM": "E-postile tööpäeviti kell 7:00",
    "Email at 3 PM": "E-postile kell 15:00",
    "Email at once": "Saada e-postile kohe",
    "Email Sundays at 11 PM": "E-postile pühapäeval kell 23:00",
    "First day of the month": "Iga kuu 1. kp",
    "to email": "E-postile kohe",
    "E-mail at once": "E-postile kohe",
    "System": "Süsteem",
    "Person": "Isik",
    "Picture": "Pilt",
    "Time zone": "Ajatsoon",
    "Calendar settings": "Kalendri seaded",
    "Public holidays": "Riigipühad",
    "Tax deadlines": "Maksude tähtajad",
    "News": "Uudised",
    "External services": "Välised teenused",
    "Agreement": "Kokkulepe",
    "Active agreement": "Kehtiv kokkulepe",
    "Weekly hours": "Töötunde nädalas",
    "Edit supplier": "Muuda tarnijat",
    "New supplier": "Uus tarnija",
    "Are you sure you wish to delete this supplier?": "Kas oled kindel, et soovid tarnija kustutada?",
    "Add supplier": "Lisa tarnija",
    "Supplier types are not defined. Please go to the suppliers app settings to add.": "Tarnijate tüübid pole seadistatud. Palun tee seda tarnijate äpi seadetes.",
    "No members yet": "Kasutajaid pole lisatud",
    "Edit group": "Muuda gruppi",
    "Add group": "Lisa grupp",
    "Are you sure to delete this user group?": "Kas oled kindel, et soovid grupi kustutada?",
    "Get set up to work with team": "Alusta tööd koos tiimiga",
    "Company account allows you to use tools for teams, get deeper insights etc. Raise the quality of your team's workflow and lead a more profitable business.": "Ettevõtte konto võimaldab Sul töötada koos tiimiga ning saada paremat ülevaadet. Tõsta oma tiimi töökvaliteeti ning juhi ettevõtet kasumlikumalt.",
    "Create company account": "Loo ettevõtte konto",
    "By creating a company account you activate Uku free subscription for {0} days.": "Uue ettevõtte konto loomisega aktiveerid Uku tasuta konto {0} päevaks.",
    "You have invited {0}/{1} members": "Sinu ettevõttel on Ukus {0}/{1} aktiivset kasutajat",
    "Upgrade": "Suurenda",
    "View profile": "Vaata profiili",
    "To add members to your team, you'll need to create a company account": "Kasutajate lisamiseks loo ettevõtte konto",
    "Export": "Ekspordi",
    "Re-invite sent": "Uus kutse saadetud",
    "View report": "Vaata raportit",
    "Member {0} will be deactivated.": "Kasutaja {0} deaktiveeritakse.",
    "Please select new member who will replace {0}.": "Palun vali uus kasutaja, kes asendab kasutajat {0}.",
    "Select new member": "Vali uus kasutaja",
    "NB! Deactivation process cannot be reversed": "NB! Deaktiveerimist ei saa tagasi pöörata.",
    "Magic button settings": "Ülesande kiirvaliku seaded",
    "Create only one task per month": "Loo ainult 1 ülesanne kuu kohta",
    "Current month's tasks": "Jooksva kuu ülesanded",
    "extra work": "lisatöö",
    "Without topic": "Ilma teemata",
    "Week": "Nädal",
    "Previous month": "Eelmine kuu",
    "task | tasks": "ülesanne | ülesannet",
    "Assign to": "Suuna kasutajale",
    "Mark as done": "Märgi tehtuks",
    "Last": "Viimati valitud",
    "Snooze": "Lükka edasi",
    "1 dependency": "1 seos",
    "{0} dependencies": "{0} seost",
    "Client request": "Kliendi päring",
    "Unread notification emails": "Lugemata teavituse e-kirjad",
    "Unread internal comments": "Lugemata sisekommentaarid",
    "Add comment": "Lisa kommentaar",
    "Internal comment": "Sisemine kommentaar",
    "Portal message": "Sõnum portaali",
    "Public message means that clients can read it and the client portal will notify them by email": "Portaali sõnumid on nähtavad kliendile ning portaali sõnumi jätmise kohta saadetakse kliendi e-postile teavitus",
    "Type a comment": "Kirjuta kommentaar",
    "Send portal message": "Saada sõnum portaali",
    "Open timesheet": "Ava ajasissekanded",
    "Pause timer": "Peata stopper",
    "Mark undone": "Märgi mitte tehtuks",
    "Digitise": "Digiteeri",
    "Documents sent to digitisation": "Dokumendid saadetud digiteerimisse",
    "Followers": "Jälgijad",
    "Start / Due date": "Algus / Tähtaeg",
    "Select topic": "Vali teema",
    "1 document": "1 dokument",
    "{0} documents": "{0} dokumenti",
    "Download": "Laadi alla",
    "Download all": "Lae alla kõik",
    "Primary contact": "Peakontakt",
    "Assign as task": "Tee ülesandeks",
    "When selected, the task is sent as a task to the client": "Ilmub ülesandena kliendile",
    "Auto finish": "Automaatne lõpetamine",
    "When selected, the task is marked done after client finishes it": "Kui klient märgib ülesande tehtuks, märgi see tehtuks ka minu jaoks",
    "Add comment / message": "Lisa kommentaar / saada sõnum",
    "Add email": "Lisa kiri",
    "Add estimation": "Lisa prognoos",
    "Add task field": "Lisa ülesande väli",
    "Add dependency": "Lisa seos",
    "Drop files to upload": "Lisa failid siia",
    "Task sent to client portal": "Ülesanne saadetud kliendiportaali",
    "Task no longer assigned to client portal": "Ülesanne ei ole enam suunatud kliendile",
    "Save recurring task": "Salvesta korduvülesanne",
    "Add to-do list": "Lisa to-do nimekirja",
    "Waiting for event status: {0}": "Oota sündmuse staatust: {0}",
    "Waiting for project status: {0}": "Ootan projekti staatust: {0}",
    "Edit template task": "Muuda korduvülesannet",
    "Create recurring task": "Loo korduvülesanne",
    "Make a copy": "Tee koopia",
    "Add topic": "Lisa teema",
    "Delete task": "Kustuta ülesanne",
    "Delete task template": "Kustuta korduvülesanne",
    "Select task field": "Vali ülesande väli",
    "No custom fields available for this client": "Sellel kliendil ei ole ühtegi lisavälja",
    "task": "ülesanne",
    "recurring task": "korduvülesanne",
    "Do you intend to remove yourself from {0} or you want to delete it completely?": "Kas soovid ennast ülesande küljest eemaldada või selle täielikult kustutada?",
    "This {1} is shared with {0}": "See {1} on jagatud kasutajaga {0}",
    "Remove only me": "Eemalda ainult mind",
    "Time has been tracked to this task.": "Selle ülesande täitmiseks on jooksutatud aega.",
    "Are you sure to delete this task?": "Kas olete kindel, et soovite selle ülesande kustutada?",
    "Undefined": "Määramata",
    "COPY": "Koopia",
    "On task due date": "Ülesande tähtajal",
    "{0} day before": "{0} päev enne",
    "{0} days before": "{0} päeva enne",
    "Edit workflow": "Muuda tööplaani",
    "Duplicate project": "Duplitseeri projekt",
    "Reset layout": "Taasta algvaade",
    "Any time": "Millal iganes",
    "1 min": "1 min",
    "5 min": "5 min",
    "10 min": "10 min",
    "30 min": "30 min",
    "1 h": "1 h",
    "Add notes": "Lisa kirjeldus",
    "Task start date": "Ülesande alguskuupäev",
    "Task due date": "Ülesande tähtaeg",
    "Recurrence task": "Korduv ülesanne",
    "Search from one time templates": "Otsi mallidest ühekordseid ülesandeid",
    "Placeholders": "Muutujad",
    "New task": "Uus ülesanne",
    "New recurring task": "Uus korduvülesanne",
    "+1 day": "+1 päev",
    "Edit comment": "Muuda kommentaari",
    "Timer is running!": "Stopper töötab!",
    "Continue time from {0}": "Määra algusajaks {0}",
    "New time entry": "Uus ajakirje",
    "Load more": "Laadi veel",
    "Are you sure to delete this time entry?": "Kas oled kindel, et soovid ajakirje kustutada?",
    "Save automated email": "Salvesta automaatne kiri",
    "Automation": "Automatiseerimine",
    "Are you sure to delete this email?": "Kas oled kindel, et soovid e-kirja kustutada?",
    "Are you sure you wish to send this email immediately?": "Kas oled kindel, et soovid saata selle kirja kohe?",
    "replied to project email": "vastas projekti e-kirjale",
    "replied to client email": "vastas kliendi e-kirjale",
    "commented": "kommenteeris",
    "Reply": "Vasta",
    "Are you sure to delete this comment?": "Kas oled kindel, et soovid kommentaari kustutada?",
    "replied to client portal email": "vastas kliendiportaali e-kirjale",
    "sent a message": "saatis kliendiportaali sõnumi",
    "replied to task email": "vastas ülesande e-kirjale",
    "failed to send": "saatmine ebaõnnestus",
    "sent email": "saatis e-kirja",
    "no one": "mitte keegi",
    "created this task.": "lõi selle ülesande.",
    "Task was automatically created from forwarded e-mail": "Ülesanne loodi automaatselt edastatud e-kirjast",
    "Task was automatically created from client portal e-mail": "Ülesanne loodi automaatselt kliendiportaali e-kirjast",
    "Task was automatically created from client e-mail": "Ülesanne loodi automaatselt kliendi e-kirjast",
    "Task was automatically created from project e-mail": "Ülesanne loodi automaatselt projekti e-kirjast",
    "requested assistance.": "soovis abi kliendiportaalis.",
    "updated this task.": "uuendas ülesannet.",
    "tracked time to this task.": "võttis ülesande töösse.",
    "finished this task.": "lõpetas ülesande.",
    "new comment.": "uus kommentaar.",
    "reassigned this task.": "suunas ülesande ümber.",
    "assigned the task to {0}.": "suunas ülesande kasutajale {0}.",
    "reminder.": "meeldetuletus.",
    "deleted.": "kustutatud.",
    "completed the task, but Uku did not auto-finish this task because not all task requirements were met.": "lõpetas ülesande, kuid ülesanne jäi avatuks, sest kõik lõpetamise tingimused ei ole täidetud.",
    "sent task to client portal": "saatis ülesande kliendiportaali.",
    "assigned the task to client.": "saatis ülesande kliendiportaali.",
    "assigned the task to company.": "võttis ülesande kliendilt tagasi.",
    "added attachment(s).": "lisas manuseid.",
    "added a comment.": "lisas kommentaari.",
    "added a message to {0}.": "saatis portaali sõnumi kasutajale {0}.",
    "received a e-mail from {0}.": "sai e-kirja {0}.",
    "updated notes.": "muutis kirjeldust.",
    "made changes to checklist.": "muutis checklisti.",
    "created this task template.": "koostas selle korduvülesande.",
    "updated this task template.": "uuendas korduvülesannet.",
    "recurring task assigned.": "suunas korduvülesande.",
    "recurring task deleted.": "kustutas korduvülesande.",
    "added email.": "lisas e-kirja.",
    "changed email.": "muutis e-kirja.",
    "deleted email.": "kustutas e-kirja.",
    "sent email.": "saatis e-kirja.",
    "failed to send.": "proovis saata e-kirja, kuid ei õnnestunud.",
    "added email": "lisas kirja",
    "changed email": "muutis e-kirja",
    "deleted email": "kustutas e-kirja",
    "Member / Time": "Kasutaja / Päev",
    "Client/topic": "Klient/teema",
    "Client/task": "Klient/ülesanne",
    "Client/member": "Klient/kasutaja",
    "Member/topic": "Kasutaja/teema",
    "Member/task": "Kasutaja/ülesanne",
    "Member/client": "Kasutaja/klient",
    "Member/date": "Kasutaja/kuupäev",
    "Date/member": "Kuupäev/kasutaja",
    "Grouped": "Grupeeritud",
    "Client/project": "Klient/projekt",
    "Project/member": "Projekt/kasutaja",
    "Period balance": "Perioodi jääk",
    "Reset balance": "Tühista",
    "Time entry has been confirmed or duration has been changed and duration will not dynamically update": "Perioodi jääk on lukus ja muudatused ülesannetes või ajakirjetes seda enam ei mõjuta",
    "(Without project)": "(Projektita)",
    "Decline": "Lükka tagasi",
    "Accept": "Kinnita",
    "Cancel decision": "Tühista",
    "Accepted": "Kinnitatud",
    "Declined": "Tagasi lükatud",
    "Report data has changed. Please update report.": "Raporti andmeid on muudetud. Palun uuenda raportit.",
    "Agreed": "Kokkulepe",
    "Non billable": "Mitte arveldatav",
    "Estimation report shows based on task start date": "Prognoosi raport näitab ülesande algusaja põhiselt",
    "Export report to Excel": "Ekspordi raport Excelisse",
    "By default, we export the result of the selected filters with the columns of the configured table": "Vaikimisi eksporditakse tabel vastavalt valitud filtritele ja veergudele",
    "Add to export client custom fields": "Lisa ekspordifaili kliendi lisaväljad",
    "Save report": "Salvesta raport",
    "Export PDF": "Ekspordi PDF",
    "Export Excel": "Ekspordi Excel",
    "Extra": "Lisa",
    "done": "valmis",
    "h": "h",
    "We have new version of": "Meil on uus versioon",
    "Log out": "Logi välja",
    "Previous day": "Eelmine päev",
    "Next day": "Jägmine päev",
    "Mark all as read": "Märgi kõik loetuks",
    "Search task/client": "Otsing",
    "from client portal": "kliendiportaalist",
    "Hide all": "Peida kõik",
    "Hide for 1 hour": "Peida 1 tunniks",
    "Something went wrong": "Midagi läks valesti",
    "User authentication needed": "Vajalik kasutaja tuvastamine",
    "Invalid rights": "Õigused puuduvad",
    "The object cannot be found": "Objekti ei leitud",
    "Content too large": "Sisu liiga suur",
    "An unknown error occurred": "Esines tundmatu viga",
    "The action requested cannot be performed": "Soovitud tegevust ei ole võimalik teostada",
    "Go": "Alusta",
    "Actual / monitoring (month)": "Tegelik / monitooring (kuu)",
    "Actual": "Tegelik",
    "Month": "Kuu",
    "I’m setting up your account": "Seadistan Sinu kontot",
    "Did you know that accounting firms that have started using Uku can serve 38% more clients in the same time.": "Kas teadsid, et raamatupidamisbürood, mis kasutavad Ukut, suudavad teenindada 38% rohkem kliente sama ajaga.",
    "Let’s setup your company": "Seadistame sinu ettevõte",
    "Name of your company": "Sinu ettevõtte nimi",
    "Size of your team?": "Kui suur on Sinu tiim?",
    "Which software are you using?": "Milliseid majandustarkvarasid kasutad?",
    "This knowledge will help us to improve Uku": "See teadmine aitab meil Ukut täiustada",
    "What other software needs to be integrated?": "Millise tarkvaraga võiks Uku veel olla integreeritud?",
    "Book a demo": "Broneeri demo",
    "Hi {0},": "Tere, {0}",
    "NO BOTS - ONLY HUMANS": "KÕNES INIMESED - EI ÜHTEGI BOTI",
    "Start a {0} day free trial": "Alusta {0} päeva tasuta prooviperioodi",
    "“Uku is an incredibly functional software. Uku boosted our work management and helps us provide exceptional service.”": "“Uku on väga praktiline tarkvara. Tänu Ukule teeme tööd tõhusamalt ning see aitab meil pakkuda erakordset teenust.”",
    "The fastest way for you to decide if Uku can benefit {0} is a short {1} min call with our customer onboarding specialist.": "Broneeri meiega kõne, et saaksime Sulle näidata, kuidas Uku {0} edule kaasa aitab.",
    "Hi, I'm Uku ": "Hei, olen Uku",
    "I help to set up your account.": "Aitan seadistada Sinu konto.",
    "It only takes a minute.": "See võtab ainult minuti.",
    "Choose": "Vali",
    "Your country": "Sinu riik",
    "Your language": "Sinu keel",
    "Begin": "Edasi",
    "Let’s become friends": "Saame sõpradeks!",
    "Your first name": "Sinu eesnimi",
    "What is your field of work?": "Valdkonnad:",
    "Your field of work": "Sinu eriala",
    "How will you use Uku?": "Kuidas hakkad Ukut kasutama? ",
    "How did you hear about Uku?": "Kust Sina Uku kohta kuulsid?",
    "Choose channel": "Vali kanal",
    "Please specify how you heard about us": "Palun lisa, kuidas te meist kuulsite",
    "Let me know Uku's new features by email": "Teavita mind Uku uuendustest",
    "Finish": "Valmis",
    "First name is required": "Eesnimi on kohustuslik",
    "Name is required": "Nimi on kohustuslik",
    "Team size is required": "Palun vali tiimi suurus",
    "Surname is required": "Perekonnanimi on kohustuslik",
    "Field is required": "Väli on kohustuslik",
    "I will use Uku to work together with two or more teammates.": "Kasutan Ukut 2 või rohkema tiimikaaslasega.",
    "I will use Uku by myself. This plan is free, but the features are limited.": "Kasutan Ukut ainult enda jaoks. See pakett on tasuta, kuid piiratud võimalustega.",
    "Media": "Meedia",
    "Through integration partner": "Integratsioonipartneri kaudu",
    "Referral by friend": "Sõber soovitas",
    "Import speeds up your clients setup, smart choice!": "Import on kiireim viis kliendiandmete lisamiseks ja uuendamiseks. Hea valik!",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} client": "Viimane import: lisatud {0}, uuendatud {1}, vahele jäetud {2}, ei õnnestunud lisada {3} klient",
    "Last import: added {0}, updated {1}, skipped {2}, failed to import {3} clients": "Viimane import: lisatud {0}, uuendatud {1}, vahele jäetud {2}, ei õnnestunud lisada {3} klienti",
    "Last import: added {0}, updated {1}, skipped {2}": "Viimane import: lisatud {0}, uuendatud {1}, vahele jäetud {2}",
    "What's next? Correct the data of {0} clients and upload again.": "Mis edasi? Paranda {0} kliendi info ja laadi fail uuesti üles.",
    "failed_to_import.xlsx": "failed_to_import.xlsx",
    "Excel (XLS, XLSX) ": "Excel (XLS, XLSX)",
    "Instead of entering clients one by one, you can use file import for a large customer base.": "Klientide ükshaaval lisamise asemel saad suure kliendibaasi importida failist",
    "Ignore": "Ignoreeri",
    "NEW CLIENT": "UUS KLIENT",
    "Preview": "Ülevaade",
    "Import started": "Import alustatud",
    "Only new clients": "Näita ainult uusi kliente",
    "Update data from company register": "Uuenda andmeid äriregistrist",
    "If switched on, the company data is updated using the local business register": "Kui see on sisse lülitatud, uuendatakse ettevõtte andmeid kohalikust äriregistrist registrikoodi alusel",
    "We did not find a match in Äriregister": "Me ei leidnud vastet Äriregistrist",
    "We did not find a match in Companies House": "Companies House vasteid ei leitud",
    "No integration yet": "Integratsiooni pole",
    "Uku match": "Uku vaste",
    "Business register nr.": "Registrikood",
    "Company register": "Äriregister",
    "Upload file": "Laadi fail üles",
    "Before uploading your file": "Enne faili üles laadimist",
    "Learn Uku’s data structure": "Tutvu Uku andmete ülesehitusega",
    "Download and use our sample file to see exactly how we organize data in Uku": "Laadi alla näidisfail, et näha, kuidas Ukus andmeid organiseeritakse",
    "Download Client Import Example": "Lae alla näidisfail klientide importimiseks",
    "Download Contact Import Example": "Lae alla näidisfail kontaktide importimiseks",
    "Fill in fields": "Täida väljad",
    "The only mandatory field is the company name. Make sure you've filled out all the necessary fields before uploading the file.": "Ainus kohustuslik väli on ettevõtte nime väli. Veendu, et oled kõik vajalikud väljad täitnud enne faili üles laadimist.",
    "Learn more about mandatory fields": "Loe rohkem kohustuslike väljade kohta",
    "Create custom fields": "Loo lisaväljad",
    "Some data fields may not be present by default. Make sure you create these custom fields before importing your data.": "Mõni väli pole vaikimisi olemas. Veendu, et oled need lisaväljad enne importimist lisanud.",
    "Add new custom fields": "Loo uued lisaväljad",
    "...or drag a file here": "…või lohista fail siia",
    "Only Excel (.xls, .xlsx) file types are supported": "Toetatud on Exceli failid (.xls, .xlsx)",
    "Mapping": "Andmete vastavusse viimine",
    "First row is a header": "Esimene rida on pealkiri",
    "Add field to all clients": "Lisa väli kõikidele klientidele",
    "Add client group": "Lisa kliendigrupp",
    "Fields for all clients": "Väljad kõigile klientidele",
    "Import of {0} in progress": "{0} import on töös",
    "Import in progress": "Import on töös",
    "It may take some time. You can do other activities in Uku at the same time, we will let you know when it is ready.": "Natuke läheb aega. Saad Ukus senikaua midagi muud teha. Anname sulle teada, kui import on valmis.",
    "Cancel import": "Tühista import",
    "Are you sure you want to cancel import?": "Kas oled kindel, et soovid impordi katkestada?",
    "Last updated": "Viimati uuendatud",
    "Contracts": "Lepingud",
    "Job name": "Malli nimi",
    "Workflow name": "Tööplaani nimi",
    "Details": "Detailid",
    "Select jobs": "Vali mallid",
    "Select task plan": "Vali mall",
    "of existing client": "olemasoleva kliendi",
    "You can also choose": "Võta aluseks",
    "existing client tasks plan": "mõne kliendi tööplaan",
    "existing predefined jobs": "eelnevalt loodud mall",
    "create a new plan": "koosta uus tööplaan",
    "Select workflow": "Vali tööplaan",
    "existing project workflow": "olemasoleva projekti tööplaan",
    "existing workflow": "olemasolev tööplaan",
    "create a new workflow": "loo uus tööplaan",
    "New tasks template": "Uus mall",
    "to save template!": "malli salvestamiseks!",
    "You can also add tasks from jobs": "Lisa ülesandeid teistest mallidest",
    "or choose": "või vali",
    "New workflow template": "Uus tööplaani mall",
    "You can also add tasks from existing workflow templates": "Lisa ülesandeid olemasolevate tööplaanide mallidest",
    "existing event workflow": "olemasoleva sündmuse tööplaan",
    "Hide others": "Peida linnutamata",
    "Update all events (New tasks)": "Uuenda kõiki sündmusi lisandunud uute ülesannetega",
    "Update all projects (New tasks)": "Uuenda kõik projektid (Uued ülesanded)",
    "Once": "Korra",
    "Once a month": "Kord kuus",
    "Once a quarter": "Kord kvartalis",
    "Once a year": "Kord aastas",
    "Company workflow": "Ettevõtte tööplaan",
    "Company jobs": "Ettevõtte mallid",
    "Default jobs": "Uku tööplaanid",
    "ID": "ID",
    "Task title and labels": "Ülesande info",
    "Assigned and time": "Kellele ja millal",
    "Setup tasks for {0} event": "Seadista ülesanded sündmusele {0}",
    "Setup tasks for {0} project": "Seadista ülesanded projektile {0}",
    "New job": "Uus mall",
    "Edit job": "Muuda malli",
    "New workflow": "Uus tööplaan",
    "Save workflow": "Salvesta tööplaan",
    "Confirm task plan": "Kinnita tööplaan",
    "Skip": "Jäta vahele",
    "Create task plan": "Lisa tööplaan",
    "Edit task plan": "Ülesannete plaani muutmine",
    "Confirm workflow": "Kinnita tööplaan",
    "Client portal templates": "Kliendiportaali mallid",
    "Jobs": "Mallid",
    "Workflows": "Tööplaanid",
    "Company workflows": "Ettevõtte tööplaanid",
    "Default workflows": "Uku tööplaanid",
    "Company template saved": "Ettevõtte mall salvestatud",
    "Company template created": "Ettevõtte mall loodud",
    "Format": "Vorming",
    "Currency": "Valuuta",
    "Reference number": "Viitenumber",
    "Invoice description": "Arve kirjeldus",
    "Summarize invoice rows": "Summeeritud arve",
    "Summarized description": "Rea kirjeldus",
    "Reverse charge": "Pöördkäibemaks",
    "Rounding": "Ümardamine",
    "Time rounding will apply for each line": "Iga rea puhul kohaldatakse aja ümardamist",
    "Rounding increment (up)": "Ümardamisjärk (üles)",
    "Reply to": "Vastuse saaja e-post",
    "Configuration": "Konfiguratsioon",
    "Invoice to parent company": "Arve emaettevõttele",
    "Create all invoices under parent company.": "Loo kõik arved emaettevõtte alla.",
    "User code": "Kasutajakood",
    "Default": "Vaikimisi",
    "Default value will apply for each line": "Iga rea puhul kohaldatakse vaikeväärtust",
    "Number": "Number",
    "You can write any of the following in curly braces to invoice prefix field. When saving the contract the prefix is filled with the corresponding value.": "Kasuta neid muutujaid koos loogeliste sulgudega arve prefiksi väljal. Kui salvestad lepingu, asendatakse arve numbris muutuja vastava väärtusega automaatselt.",
    "Copy to clipboard": "Kopeeri lõikelauale",
    "Invoice previous period": "Arve eelmine periood",
    "Invoice period": "Arve periood",
    "Invoice next period": "Arve järgmine periood",
    "Client primary user": "Kliendi peakasutaja",
    "Original client name": "Esialgne kliendi nimi",
    "invoice date year": "arve koostamise aasta",
    "last two digits of invoice date year": "arve koostamise aasta viimased kaks numbrit",
    "invoice date month": "arve koostamise kuu",
    "invoice date day": "arve koostamise päev",
    "Contract": "Leping",
    "Net total": "Kogusumma",
    "Contract #": "Leping #",
    "Invoice #": "Arve nr",
    "Exported": "Eksporditud",
    "Sent": "Saadetud",
    "Net": "Neto",
    "Add invoice": "Lisa arve",
    "Change invoice number": "Muuda arve numbrit",
    "Review changes": "Kontrolli muudatused",
    "Please review and approve changes to the related events": "Kontrolli ja kinnita muudatused seotud sündmustele",
    "Please review and approve changes to the related projects": "Palun kontrolli üle ja kinnita, kas soovid teha muudatusi järgnevates projektides",
    "Contains": "Sisaldab",
    "contains": "sisaldab",
    "Exactly": "Võrdub",
    "is exactly": "on võrdne",
    "Greater than": "Suurem kui",
    "is greater than": "on suurem kui",
    "Less than": "Väiksem kui",
    "is less than": "on väiksem kui",
    "Range": "Vahemik",
    "is in range of": "on vahemikus",
    "is empty": "on tühi",
    "Task plan": "Ülesannete plaan",
    "Edit plan": "Muuda plaani",
    "Use task plan templates to set up tasks effectively or add a task manually": "Seadista ülesannete mallid, et rakendada neid enda klientidele, või lisa ülesanne käsitsi",
    "Add task manually": "Lisa ülesanne käsitsi",
    "Quarterly": "Iga kvartal",
    "Export excel": "Eksport Excelisse",
    "Print PDF": "Prindi PDF",
    "Edit jobs": "Muuda malle",
    "Replace plan tasks with job": "Asenda plaan malliga",
    "Select template": "Vali mall",
    "member": "kasutaja",
    "Tasks with user will be added to every selected client": "Ülesanded kasutajaga lisatakse igale valitud kliendile",
    "Add even if job already applied": "Lisa isegi kui seda malli on juba rakendatud",
    "Default user": "Vaikimisi kasutaja",
    "This will delete all tasks from client plan and put only selected template’s tasks in it": "Sellega kustutad Sa kõik ülesanded kliendi tööplaanist ja asendad need ülesannetega valitud mallist",
    "Adding template will be ready in a minute. You can continue with work.": "Mallide lisamine võib võtta minuti. Võid tööga jätkata.",
    "Add client": "Lisa klient",
    "Export clients": "Ekspordi kliendid",
    "Export client contacts": "Ekspordi kliendikontaktid",
    "client | clients": "klient | klienti",
    "clients": "klienti",
    "client(s) had errors": "kliendil oli viga | klientidel oli vigu",
    "client(s) selected": "klienti valitud",
    "Contract actions": "Lepingu tegevused",
    "Edit Members": "Muuda kasutajaid",
    "Edit monitoring": "Muuda monitooringut",
    "Your company": "Sinu ettevõte",
    "Edit billing": "Muuda arveldamist",
    "Activate client portal": "Aktiveeri kliendiportaal",
    "After activation, you can send tasks directly to all client's contacts who have an e-mail address.": "Pärast aktiveerimist saad saata ülesandeid kõigile e-postiga kliendikontaktidele",
    "Send welcome invitation to client contacts": "Saada kliendi kontaktidele tervituskiri kutsega kliendiportaali",
    "Who will receive an invitation?": "Kes saab kutse?",
    "Client contact who has one valid e-mail address": "Kliendi kontakt, kel on täpselt üks korrektne e-posti aadress",
    "Client contact who has the client's portal open (default for all)": "Kliendi kontakt, kes on kliendiportaali lubatud",
    "How does the invitation work?": "Kuidas see kutsumine toimib?",
    "Uku creates and sends a 'Welcome task' to each client contact. It's created by the client primary user based on the 'Welcome to the Customer Portal' task template. Check it out under your company task templates. It will be translated according to the contact language.": "Uku loob ja saadab igale kliendi kontaktile kliendi vaikimisi kasutaja nimel tervitus-ülesande. Ülesanne luuakse kliendiportaali ülesannete malli alusel - leiad selle Kliendiportaali rakendusest mallide alt. Sobilik mall valitakse vastavalt kontakti keelele.",
    "Uku client portal always informs clients by email about new tasks.": "Uku kliendiportaal teavitab kliente uutest ülesannetest e-posti teel",
    "View templates": "Vaata malle",
    "Client portal activated": "Kliendiportaal aktiveeritud",
    "Company's name": "Ettevõtte nimi",
    "Mark": "Tähis",
    "Add members": "Lisa kasutaja",
    "Members and groups": "Kasutajad ja grupid",
    "Topic is required": "Teema on kohustuslik",
    "Entering time is required": "Aja märkimine on kohustuslik",
    "Delete client": "Kustuta klient",
    "Manage client fields": "Seadista kliendi väljasid",
    "Max 3 characters": "Max 3 tähte",
    "Are you sure you wish to delete this client?": "Kas oled kindel, et soovid kliendi kustutada?",
    "Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted": "NB! Kliendi andmete kustutamisel kustutatakse ka kõik kliendiga seotud ülesanded, ajakirjed ja kliendi ajalugu",
    "Owner": "Omanik",
    "All clients that you add under {0} will be deleted later.</div>": "Kõik {0} alla lisatud kliendid kustutatakse hiljem.</div>",
    "Use this account for testing purposes only!": "Kasuta seda kontot ainult testimise eesmärgil!",
    "Read more about the demo account": "Loe lähemalt demo konto kohta",
    "Rights": "Õigused",
    "Monitoring setup": "Monitooringu seadistamine",
    "Learn more about monitoring": "Loe täpsemalt monitooringu kohta",
    "selected": "valitud",
    "Resend": "Saada uuesti",
    "Invoicing": "Arvete esitamine",
    "Billing template": "Arveldamise mall",
    "New": "Uus",
    "Add row": "Lisa rida",
    "Delete contract": "Kustuta leping",
    "Product / description": "Toode / kirjeldus",
    "Qty": "Tk",
    "Product placeholders": "Toote muutujad",
    "You can write any of the following lines in curly brackets to product description. When saving an invoice it will replace the text with the corresponding value.": "Kasuta järgmisi muutujaid koos loogiliste sulgudega toote kirjelduses. Kui salvestad arve, asendatakse see tekst vastava väärtusega.",
    "Template saved": "Mall salvestatud",
    "Warning": "Hoiatus",
    "Would you like to apply these changes to all clients using this contract template?": "Kas soovid antud muudatused rakendada ka seotud kliendilepingutes?",
    "Yes, apply to all clients": "Jah, muuda ka seotud kliendilepingud",
    "You have made changes to time period that this billing contract applies to. This may change how affected unbilled services in the past and future will be invoiced. Please confirm that this change was intentional.": "Oled teinud muudatusi ajaperioodis, millele see arveldusleping kehtib. See võib mõjutada, kuidas minevikus või tulevikus arveldamata teenuste eest arveldatakse. Palun kinnita, et soovid lepingu kehtivusaega muuta.",
    "Are you sure to delete this template?": "Kas oled kindel, et soovid malli kustutada?",
    "Save template": "Salvesta mall",
    "Save as template": "Salvesta malliks",
    "Please note all changes made to contract will be lost": "Muudatuste tegemisel olemasolev leping asendatakse",
    "Add contract": "Lisa leping",
    "Manage contract templates": "Halda lepingu malle",
    "Edit account details": "Konto andmete muutmine",
    "Country is required": "Riik on kohustuslik",
    "Postal code": "Postiindeks",
    "State": "Maakond",
    "Uku is set up according to the field of work.": "Uku on seadistatud vastavalt tegutsemisvaldkonnale.",
    "Size of the team": "Tiimi suurus",
    "Website": "Veebileht",
    "Delete account": "Kustuta konto",
    "Deleting an account will also delete all clients associated with the account, their tasks, and their entire history. Are you sure that you want to delete your account?": "Konto kustutamine kustutab ka kõik kontoga seotud kliendid, ülesanded ja kogu ajaloo. Kas oled kindel, et soovid konto kustutada?",
    "Yes, delete the account with all related data such as clients, tasks, and all history": "Jah, kustuta konto koos kõikide seotud andmetega nagu kliendid, ülesanded ja kogu ajalugu",
    "These invoices cannot be sent. Check their status or error messages.": "Valitud arveid ei saa kliendile saata. Palun kontrolli nende staatust või veateateid.",
    "Please confirm that you wish to proceed.": "Palun kinnita, et soovid jätkata.",
    "Sending invoice | Sending invoices": "Saadan arvet | Saadan arveid",
    "You are about to e-mail this invoice to customer. | You are about to e-mail these invoices to customers.": "Oled saatmas seda arvet kliendile. | Oled saatmas neid arveid klientidele.",
    "Error in calculating invoice": "Viga arve kalkuleerimisel",
    "Error in importing invoice": "Arve importimine ebaõnnestus",
    "Error in creating invoice": "Viga arve koostamisel",
    "Error in exporting invoice": "Viga arve eksportimisel",
    "Error in sending invoice": "Viga arve saatmisel",
    "Calculating invoice": "Arve kalkuleerimine",
    "Creating invoice": "Loon arvet",
    "Exporting invoice": "Eksportimisel",
    "Importing invoice": "Impordin arvet",
    "Sending invoice": "Saatmisel",
    "Clear errors": "Tühista vead",
    "Related work will be made billable again. The invoices will not be deleted from external systems, you will have to do that manually.": "Seotud tööd muutuvad taas arveldatavaks. Arveid ei kustutata välistest süsteemidest automaatselt - seda tuleb teha käsitsi.",
    "Delete invoice | Deleting invoices": "Kustuta arve | Kustuta arved",
    "Selected net total": "Valiku kogusumma",
    "Nothing in invoices": "Arveid ei leitud",
    "Please make sure you have setup recurring billing for your clients": "Veenduge, et olete oma klientidele seadistanud korduva arvelduse",
    "Draft": "Töös",
    "Approval": "Kinnitada",
    "Created": "Koostatud",
    "Coming soon": "Varsti tulemas",
    "Selected invoices and related product info will be sent to accounting system.": "Valitud arved koos toote infoga saadetakse raamatupidamissüsteemi.",
    "Piece": "Tükk",
    "Hour": "Tund",
    "Delete row": "Kustuta rida",
    "Out of ": "Valitud",
    " can be created": " saab luua",
    "For ": " ",
    " invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": " arveldusperiood veel kestab. Pärast arve koostamist selles perioodis uusi töid ei arveldata.",
    "Invoice date will be set to today.": "Arve kuupäevaks määratakse tänane kuupäev.",
    "Uku is about to create": "Uku on loomas",
    " selected row, only | selected row, only ": "valitud rida ainult | valitud rida ainult",
    " invoice | invoices": "arve | arvet",
    "These invoices cannot be exported. Check their status or error messages.": "Valitud arveid ei saa eksportida. Palun kontrolli nende staatust või veateateid.",
    "Exporting invoice | Exporting invoices": "Arve eksport | Arvete eksport",
    "You are about to export this invoice to accounting. | You are about to export these invoices to accounting.": "Oled eksportimas arvet raamatupidamisprogrammi. | Oled eksportimas arveid raamatupidamisprogrammi.",
    "This invoice has already been exported. Are you sure you want to export it as a new invoice? | Some of these invoices have already been exported. Are you sure that you want to export them as new invoices?": "See arve on juba eksporditud. Kas oled kindel, et soovid seda eksportida kui uut arvet? | Mõned arved on juba eksporditud. Kas oled kindel, et soovid neid eksportida kui uusi arveid?",
    "Download pdf": "Laadi alla PDF",
    "Create invoice": "Koosta arve",
    "Update status from {0}": "Uuenda staatust {0}-st",
    "Show all lines": "Näita kõiki ridu",
    "Calculate invoice": "Arvuta arve",
    "Loading invoice...": "Arve laadimine...",
    "Invalid Scoro credentials": "Scoro ligipääsu tunnused ei kehti",
    "Please confirm the changes you have made to this invoice.": "Palun kinnita, et soovid arvesse tehtud muudatused salvestada.",
    "NB! Note that changed invoice will not be automatically sent to customer or exported to external systems - you will have to do this manually.": "NB! Muudetud arvet ei saadeta automaatselt kliendile ega ei ekspordita kolmandatele osapooltele - seda tuleb teha käsitsi.",
    "Invoice number already exists! Please confirm to save anyway.": "Arve number on juba olemas! Palun kinnitage, et soovite ikkagi salvestada.",
    "Error in data": "Viga andmetes",
    "The invoicing period is still ongoing. Any work done in this period after creation of the invoice will not be invoiced.": "Arveldusperiood veel kestab. Pärast arve koostamist antud perioodis uusi töid ei arveldata.",
    "Creation date": "Loomise kuupäev",
    "{0} days after": "{0} päeva pärast",
    "{0} day after": "{0} päev pärast",
    "right away when": "kohe",
    "start date": "alguskuupäev",
    "due date": "tähtaeg",
    "finished": "lõpetatud",
    "Entries count": "Kannete arv",
    "Entries excluding sales": "Kanded v.a. müük",
    "Entries excluding bank": "Kanded v.a. pank",
    "Entries excluding documents": "Kanded v.a. dokumendid",
    "Documents (sales and purchases)": "Dokumendid (ost ja müük)",
    "Cash entries": "Kassa kanne",
    "VAT entries": "Käibedeklaratsiooni kanne",
    "Stock entries": "Lao kanne",
    "Sale entries": "Müügi kanne",
    "Purchase entries": "Ostu kanne",
    "Bank entries": "Panga kanne",
    "Ledger entries": "Pearaamatu kanne",
    "Depreciation entries": "Amordi kanne",
    "Entry lines count": "Kirjete ridade arv",
    "Transaction create": "Makse loomine",
    "Transaction update": "Makse uuendamine",
    "Purchase invoice create": "Ostuarve loomine",
    "Purchase invoice update": "Ostuarve uuendamine",
    "Sales invoice create": "Müügiarve loomine",
    "Sales invoice update": "Müügiarve uuendamine",
    "Financial entry create": "Finantskande loomine",
    "Financial entry update": "Finantskande uuendamine",
    "Expense row create": "Kulurea loomine",
    "Expense row update": "Kulurea uuendamine",
    "Depreciation create": "Põhivara amortisatsiooni loomine",
    "Depreciation update": "Põhivara amortisatsiooni uuendamine",
    "Person count": "Aktiivsete aruandvate isikute arv",
    "Fixed assets": "Amortiseeritavate põhivarade arv",
    "Company owner": "Ettevõtte omanik",
    "Activity": "Tegevus",
    "Oldest first": "Vanim enne",
    "Newest first": "Uuem enne",
    "Quantity as time": "Kogus ajana",
    "Quantity as number": "Kogus numbrina",
    "Quantity as time in number format": "Kogus ajana numbrivormingus",
    "No rounding": "Ei ümardata",
    "min": "min",
    "hour": "tund",
    "Last day of month": "Kuu viimane päev",
    "Invoice line": "Arverea põhiselt",
    "Task time total (per member)": "Ülesande põhiselt (liikme kohta)",
    "Time entry": "Ajakirje kuupäev",
    "Task finish date": "Ülesande lõpetamise kuupäev",
    "Create separately": "Loo eraldi",
    "Merge into one": "Koosta üks arve",
    "No minimum": "Miinimum puudub",
    "{0} minute": "{0} minut",
    "{0} minutes": "{0} minutit",
    "{0} hour": "{0} tund",
    "{0} hours": "{0} tundi",
    "English": "Inglise",
    "Estonian": "Eesti",
    "Danish": "Taani",
    "Lithuanian": "Leedu",
    "Russian": "Vene",
    "Finnish": "Soome",
    "Swedish": "Rootsi",
    "Norwegian": "Norra",
    "Latvian": "Läti",
    "Bulgarian": "Bulgaaria",
    "German": "Saksa",
    "Spanish": "Hispaania",
    "Polish": "Poola",
    "Field: ": "Väli: ",
    "Normal hours": "Tavatunnid",
    "Year": "Aasta",
    "Estonia": "Eesti",
    "Finland": "Soome",
    "Poland": "Poola",
    "User": "Kasutaja",
    "None": "Tühi",
    "Error!": "Tõrge!",
    "Pending": "Ootel",
    "Finished": "Lõpetatud",
    "Text": "Tekst",
    "Choice": "Valik",
    "Yes/No": "Jah/Ei",
    "Integer": "Täisarv",
    "Multiple choice": "Mitu valikut",
    "URL": "URL",
    "Multiple users": "Mitu kasutajat",
    "Multiline text": "Pikk tekst",
    "Must be a integer": "Peab olema täisarv",
    "Must be a date": "Peab sisestama kuupäeva",
    "Must be a valid e-mail address": "Peab olema kehtiv e-posti aadress",
    "Unknown choice": "Tundmatu valik",
    "Some errors occurred:": "Tekkisid vead:",
    "Unknown network error": "Tundmatu ühenduse viga",
    "Could not connect to the service": "Ei saanud teenusega ühendust",
    "Reload this page": "Laadi leht uuesti",
    "Invoice paid": "Arve tasutud",
    "Annulled": "Tühistatud",
    "Processing": "Töös",
    "You are about to deactivate this app.": "Oled seda äppi deaktiveerimas.",
    "You are about to disconnect this app.": "Oled lahti ühendamas seda rakendust.",
    "Do you also want to activate billing to get the most out of Uku?": "Kas soovid aktiveerida arveldamise, et Ukust viimast võtta?",
    "Invoice": "Arve",
    "Clients - Monitoring": "Kliendid - Monitooring",
    "Links": "Viited",
    "New template": "Uus mall",
    "Import Clients from Excel": "Klientide importimine Exceliga",
    "Importer": "Import",
    "Import clients from Excel": "Impordi kliendid Excelist",
    "Account settings": "Konto seaded",
    "Empty": "Tühi",
};
export default translations